/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    AppBar,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Paper,
    styled,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import { FC, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import adminStore from "src/store/AdminStore";
import { ComponenteProjeto, Projeto, TCategoriasComponentes, TPedidosHistoricos, TPedidosHistoricosComponentes } from "./types";
import theme from "src/theme/light";
import { FindInPageOutlined, InfoOutlined, LaunchOutlined, Link, Email, WhatsApp } from "@mui/icons-material";
import { ModalVisualizarProposta, TiposVisualizacaoProposta } from "./acoes/visualizarProposta/ModalVisualizarProposta";
import { TermosFinalizar } from "./containers/TermosFinalizar";
import { CarrinhoKitsResponse, ProjetosProvider } from "src/providers/ProjetosProvider";
import {CopyToClipboard} from "react-copy-to-clipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import React from "react";
import { ModalDetalhes as ModalDetalhesComponentes }  from '../componentes/ModalDetalhes'
import { useObservable } from "src/framework/store/storeUtil";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import jwtDecode from "jwt-decode";
import { FORMA_PAGAMENTO_BOLETO, FORMA_PAGAMENTO_CARTA_CREDITO, FORMA_PAGAMENTO_CARTAO_CREDITO, FORMA_PAGAMENTO_FINANCIAMENTO, FORMA_PAGAMENTO_PIX, FORMA_PAGAMENTO_VAREJO, FORMAS_PAGAMENTO_UNICO, formatarStatusPagamento, parseFormaPagamentoHistorico, parseSituacoesPagamento } from "./Cards";
import { ORDEM_GRUPO_CATEGORIAS, STATUS_COMISSIONAMENTO } from "./constants";
import LoadingSpinner from "./utils/loading";
import { PagamentoNotificacao } from "../vendas/types";
import { TipoPropostaModal } from "./containers/ModalTipoProposta";
import { MENSAGEM_OBSERVACAO_CANCELADO, MENSAGEM_OBSERVACAO_EXPIRADO } from "src/constants";
import { arraySort } from "./historico/HistoricoMigrado/utils/actions";
import { uniqBy } from "lodash";
import jwt from 'jwt-simple';

import EnviarPagamentoButton from "./utils/enviarPagamentoButton";
import { CacheType, categorias_componentes$, contaUsuario$, mensagemWhatsAppProposta$, resolveProtocolUrl } from "src/store/global.store";
import { ORIGEM_HISTORICO_V1 } from "./historico/Historico";
import { UrlUtil } from "src/framework/commons/UrlUtil";
import { BASE_TEXT } from "./acoes/visita";
import { ModalBaixarProposta } from "./acoes/baixarProposta/ModalBaixarProposta";
import { TIPO_CONTA_VAREJO } from "src/types";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { isMobile } from "./utils/deviceUtils";
import { LoginStore } from "src/framework/store/LoginStore";
import { bateriasMap, ID_BATERIA_HIBRIDA, inversoresMap, LISTA_BATERIAS, TGrupoCategoria } from "../componentes/types";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";
import { DateUtil } from "src/framework/commons/DateUtils";
import { WhatsAppUtil } from "src/framework/commons/WhatsAppUtil";
import { isHibrido } from "./utils/projetoHibrido";

/* eslint-disable react-hooks/rules-of-hooks */
type OptionTensao = {
    id: string;
    nome: string;
}
const OPTIONS_TENSAO: OptionTensao[] = [
  {
    id: '127',
    nome: '127V Monofásico (CA)',
  },
  {
    id: '220',
    nome: '220V Monofásico (CA)',
  },
  {
    id: '127/220',
    nome: '220V Trifásico (CA)',
  },
  {
    id: '220/380',
    nome: '380V Trifásico (CA)',
  },
  {
    id: '24',
    nome: '24V (CC)',
  },
  {
    id: '48',
    nome: '48V (CC)',
  }
];

interface ModalDetalhesParms {
    open: boolean;
    setOpenModal: Function;
    projetoId?: number;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const INIT_KIT = {
    id: 0,
    guid: "",
    itens: [],
}

const maskPhone = ((phone: any)=>{
    let _phone = phone;
    _phone = _phone?.replace(/\D/g, "");
    _phone = _phone.replace(/^0/, "");

    if (_phone?.length > 10) {
        _phone = _phone?.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (_phone?.length > 5) {
        _phone = _phone?.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
    } else if (_phone?.length > 2) {
        _phone = _phone?.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else if (_phone?.length > 1) {
        _phone = _phone?.replace(/^(\d*)/, "($1");
    }

    return _phone;
})

export const parseFase = (fase: number) => {
    switch (fase) {
        case 1:
            return "Monofásico";

        case 2:
            return "Bifásico";

        case 3:
            return "Trifásico";
    }
}

export const parseTensao = (tensao: number, hibrido?: boolean) => {
    switch (tensao) {
        case 1:
            if(hibrido) return "220";
            return "127/220";

        case 2:
            return "220/380";
    }
}
const parseTensaoOffgrid = (tensao: string) => {
    return OPTIONS_TENSAO.find((item: OptionTensao)=> item.id === tensao)?.nome;
}

export const parseSituacaoHistorico = (forma: string, dados_integracao: any, index = 0) => {
    switch(forma){        
        case "pix":
            const dadosPix = dados_integracao[forma]?.sort((a: any, b: any) => {
                return Date.parse(b?.created_at || b?.data_expiracao) - Date.parse(a?.created_at || a?.data_expiracao)
            });
            if(dadosPix[0]){
                switch(dadosPix[0]?.situacao){
                    case "pendente":
                        return "Aguardando Pagamento";
                    case "gerado":
                        return "Aguardando Pagamento";
                    case "pago":
                        return "Pago";
                    case "cancelado":
                        return "Cancelado";
                    case "recusado":
                        return "Recusado";
                    default:
                        return "-";
                }
            }
            return "-";
        case "boleto":
            const dadosBoleto = dados_integracao[forma]?.sort((a: any, b: any) => {
                return Date.parse(b?.created_at || b?.data_vencimento) - Date.parse(a?.created_at || a?.data_vencimento)
            });
            if(dadosBoleto[0]){
                switch(dadosBoleto[0]?.situacao){
                    case "pendente":
                        return "Aguardando Pagamento";
                    case "gerado":
                        return "Aguardando Pagamento";
                    case "pago":
                        return "Pago";
                    case "cancelado":
                        return "Cancelado";
                    case "recusado":
                        return "Recusado";
                    default:
                        return "-";
                }
            }
            return "-";
        case "cartao_credito":
            if(dados_integracao[forma][index]){
                switch(dados_integracao[forma][index]?.situacao){
                    case "pendente":
                        return "Aguardando Pagamento";
                    case "autorizado":
                        return "Autorizado";
                    case "capturado":
                        return "Pago";
                    case "pago":
                        return "Pago";
                    case "cancelado":
                        return "Cancelado";
                    case "recusado":
                        return "Recusado";
                    default:
                        return "-";
                }
            }
            return "-";
        case "carta_credito":
            if(dados_integracao[forma][0]){
                switch(dados_integracao[forma][0]?.situacao){
                    case "pendente":
                        switch(dados_integracao[forma][0]?.etapa_financiamento){
                            case "carta_credito_pendente":
                                return "Aguardando carta de crédito";
                            case "carta_credito":
                                return "Aguardando análise de documento";
                            case "implantacao_pedido":
                                return "Aguardando implantação do pedido";
                            case "emissao_nota":
                                return "Aguardando emissão de Nota Fiscal";
                            case "comprovante_pagamento_pendente":
                                return "Aguardando confirmação do pagamento";
                            case "comprovante_pagamento":
                                return "Aguardando análise do comprovante";
                        }                        
                        break;
                    case "pago":
                        switch(dados_integracao[forma][0]?.etapa_financiamento){
                            case "emissao_nota":
                                return "Aguardando emissão de Nota Fiscal";
                            case "comprovante_pagamento":
                                return "Aguardando análise do comprovante";
                            case "comprovante_pagamento_pendente":
                                switch(dados_integracao[forma][0]?.situacao_comprovante){
                                    case "revisao":
                                        return "Recusado"
                                }
                                return "Aguardando confirmação do pagamento";
                            default:
                                return "Pago";
                        }
                    case "recusado":
                        return "Recusado";
                    case "cancelado":
                        return "Cancelado";
                    case "faturamento":
                        return "Aguardando emissão de Nota Fiscal";
                    default:
                        return "-";
                }
            }
            return "-";
        case "financiamento":
            if(dados_integracao[forma][0]){
                switch(dados_integracao[forma][0]?.situacao){
                    case "pago":
                        return "Pago";
                    case "recusado":
                        return "Recusado";
                    case "cancelado":
                        return "Cancelado";
                    case "faturamento":
                        switch(dados_integracao[forma][0]?.situacao_financiamento){
                            case "aguardando_pagamento":
                                return "Aguardando confirmação do pagamento";
                        }
                        return "Aguardando emissão de Nota Fiscal";  
                    case "pendente":
                        switch(dados_integracao[forma][0]?.situacao_financiamento){
                            case "proposta":
                                const ccRecusado = dados_integracao?.["cartao_credito"] && dados_integracao?.["cartao_credito"].length ? dados_integracao?.["cartao_credito"]?.[0].situacao === "recusado" : undefined;
                                return ccRecusado ? "-" : "Aguardando preenchimento do formulário";
                            case "planos":
                                return "Aguardando confirmação de planos";
                            case "documentos_cliente":
                                return "Aguardando documentos";
                            case "documentos_financeiro":
                                return "Aguardando análise de documento";
                            case "solicitar_assinatura":
                                return "Aguardando assinatura do contrato";
                            case "assinatura":
                                return "Aguardando assinatura do contrato";
                            default:
                                return "-"
                        }
                    default:
                        return "-";
                }
            }
            return "-";
        default:
            return "-";
    }
}

const DEFAULT_TABLIST = [
    {text: "RESUMO", value: 0, allowed: true },
    {text: "PRODUTOS", value: 1, allowed: true },
    {text: "DISTRIBUIDOR", value: 2, allowed: false },
    {text: "REVENDA", value: 3, allowed: false },
    {text: "CLIENTE", value: 4, allowed: true },
    {text: "PAGAMENTO", value: 10, allowed: true },
    {text: "NOTA FISCAL", value: 11, allowed: true },
    {text: "PEDIDO", value: 12, allowed: true },
    {text: "ENTREGAS", value: 13, allowed: true },
    {text: "PREVISÃO DE FATURAMENTO", value: 14, allowed: true },
    {text: "CONFIRMAÇÃO VISITA TÉCNICA", value: 20, allowed: false },
    {text: "TERMOS DO PROJETO", value: 21, allowed: false },
    {text: "FINALIZAÇÃO DE PROJETO", value: 22, allowed: false },
];

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    const classes = useStyles();

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tabpanel-${index}`}
        className={classes.body}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

function a11yProps(index: any) {
    return {
      id: `scrollable-auto-tabpanel-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
      value: index
    };
  }

const useStyles = makeStyles({
  table: {
      minWidth: 860,
    },
  root: {
    minWidth: 275,
  },
  body: {
      width: "100%",
      minWidth: "910px"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  principal: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: '10px',
  },
  pos: {
    fontSize: 14,
    marginBottom: 12,
  },
  label: {
    fontSize: 14,
    marginBottom: 5,
  },
  tableHistorico: {
      cursor: 'pointer',
  },
  paper:{
      border: '1px solid',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
  },
  link: {
      all: "unset",
      color: "blue",
      textDecoration: "underline",
      cursor: "pointer",
      position: "relative"
  },
  icon: { 
      top: "2px",
      color: "blue", 
      fontSize: "18px",
      fontWeight: "bold",
      paddingLeft: "2px",
      position: "absolute"
  }
});

const VerticalButton = styled(Button)(({ theme }) => ({
  flexDirection: isMobile() ? 'row' : 'column',
  padding: `${theme.spacing(0.1)} ${theme.spacing(0.75)}`, 
  minWidth: 'auto', 
  minHeight:  isMobile() ? "40px" : 'auto', 
  fontSize: '0.625rem',
  '& .MuiButton-label': {
    flexDirection: isMobile() ? 'row' : 'column',
    fontSize: '0.625rem',
  },
  '& .MuiButton-startIcon': {
    margin: isMobile() ? "0px 10px" : 0,
    marginBottom: theme.spacing(0.25),
    // Estilos para o ícone
    '& > *:first-of-type': {
      fontSize: '1.25rem',
    },
  },
}));

export const buscaTipoDePropostaDeAcordoComPermissao = (permissoes: string[]) => {
    let tipoProposta = TiposVisualizacaoProposta.SIMPLIFICADA

    if (PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes)) {
        tipoProposta = TiposVisualizacaoProposta.DETALHADA
    }

    if (PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)) {
        tipoProposta = TiposVisualizacaoProposta.SIMPLIFICADA
    }

    return tipoProposta
}

const projetosProvider = new ProjetosProvider()

const ModalDetalhes: FC<ModalDetalhesParms> = (modalDetalhesModel) => {
    const categoriasComponentes = useObservable<CacheType<TCategoriasComponentes[]>>(categorias_componentes$)
    const mensagemWhatsAppProposta = useObservable(mensagemWhatsAppProposta$)
    const [valueState, setValueState] = useState<number>(0);
    const [pedidoEstate, setPedido] = useState<any>();
    const [kits, setKits] = useState<CarrinhoKitsResponse>(INIT_KIT);
    // historico pagamentos
    const [pagamentoHistoricoEstate, setPagamentoHistorico] = useState<any>();
    const [pagamentoHistoricoLinhaEstate, setPagamentoHistoricoLinha] = useState<any>();
    // historico nf
    const [nfHistoricoEstate, setNFHistorico] = useState<any>();
    const [nfHistoricoLinhaEstate, setNFHistoricoLinha] = useState<any>();
    const [nfShowEstate, setNFShowLinha] = useState<any>();
    const [projetoState, setProjetoState] = useState<Projeto>();
    // historico projeto migrado
    const [historicosProjeto, setHistoricosProjeto] = useState<any[]>([]);
    // Visualizar proposta
    const [openModalVisualizarProposta, setOpenModalVisualizarProposta] = useState<boolean>(false);
    const [openModalBaixarProposta, setOpenModalBaixarProposta] = useState<boolean>(false);
    const [baixarProposta, setBaixarProposta] = useState<boolean>(false);
    const [tipoVisualizacaoProposta, setTipoVisualizacaoProposta] = useState<TiposVisualizacaoProposta>();
    const [copied, setCopied] = useState<boolean>(false);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [controlDisplay, setControlDisplay] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [pedidoNotificacoes, setPedidoNotificacoes] = useState<PagamentoNotificacao[]>([])
    const [tipoPropostaModalIsOpened, setTipoPropostaModalIsOpened] = useState<{ status: boolean; origem: 'visualizar' | 'whatsapp' | '' }>({ status: false, origem: '' })
    const [refreshState, setRefreshState] = useState<boolean>(false);
    const [pedidoHistoricosErp, setPedidoHistoricosErp] = useState<TPedidosHistoricos[]>([])
    const [pedidoShowHistoricosErp, setPedidoShowHistoricosErp] = useState<TPedidosHistoricos>()
    const [pedidoLinhaHistoricosErp, setPedidoLinhaHistoricosErp] = useState<TPedidosHistoricos>()

    const [estruturasPedidosHistoricosState, setEstruturasPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [acessoriosPedidosHistoricosState, setAcessoriosPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [inversoresPedidosHistoricosState, setInversoresPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [bateriasPedidosHistoricosState, setBateriasPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [controladoresPedidosHistoricosState, setControladoresPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [modulosPedidosHistoricosState, setModulosPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [iluminacaoPedidosHistoricosState, setIluminacaoPedidosHistoricosState] = useState<TPedidosHistoricosComponentes[]>([]);
    const [copiedPagamento, setCopiedPagamento] = useState<{exibir: boolean, erro: boolean, texto: string, email?: boolean}>({exibir: false, erro: false, texto: ''});
    const [modalComponentesDetalhesData, setModalComponentesDetalhesData] = useState(0);
    
    const [tabMobile, setTabMobile] = useState<number>(0);
    const [currentHistoricoPedido, setCurrentHistoricoPedido] = useState<string>("");
    const [currentHistoricoPagamento, setCurrentHistoricoPagamento] = useState<string>("");
    const [currentHistoricoNf, setCurrentHistoricoNf] = useState<string>("");
    const [loadingNf, setLoadingNf] = useState<boolean>(false);
    const avulso = projetoState?.tipo === "avulso";

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const FooterBottom = isMobile ? Box : DialogActions;

    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    const contaUsuario = useObservable(contaUsuario$)

    const projetoV1 = (projetoState?.migrado || projetoState?.origem === "V1");
    const criado_em = projetoV1 ? projetoState?.data_criacao : projetoState?.created_at;
    const pedido_endereco = (projetoV1 && pedidoEstate?.cliente?.dados_endereco) || pedidoEstate?.endereco;
    const turnkey = projetoState?.tipo === 'vertical' && projetoState?.servico === 'intelbras';

    const uploadInfo = LocalStorage.get("solar.uploadInfo", true);
    const danfeNF = useMemo(() => {
        return nfShowEstate?.uploads?.find((u: any) => u?.tipo === 'danfe' && !!u?.url);
    }, [nfShowEstate]);
    
    const xmlNF = useMemo(() => {
        const contaVarejo = projetoState?.distribuidor?.tipo_conta_id === TIPO_CONTA_VAREJO;
        const faturamentoTriangular = projetoState?.tipo_faturamento === "integrador_cliente";
        return (contaVarejo && faturamentoTriangular) && nfShowEstate?.uploads?.find((u: any) => u?.tipo === 'xml' && !!u?.url);
    }, [nfShowEstate, projetoState?.tipo_faturamento, projetoState?.distribuidor?.tipo_conta_id]);
    
    const classes = useStyles();

    useEffect(()=>{
        if (avulso && valueState === 0){
            setValueState(1);
        }
    },[avulso])

    const is15MinutesBeforeNow = useCallback(()=>{
        if (!projetoState?.data_envio_link_pagamento) {
            return true;
        }

        const targetDate = new Date(projetoState?.data_envio_link_pagamento || new Date());
        
        const now = new Date();

        const fifteenMinutesInMilliseconds = 15 * 60 * 1000;


        const fifteenMinutesBeforeNow = now.getTime() - fifteenMinutesInMilliseconds;


        return targetDate.getTime() < fifteenMinutesBeforeNow;
    }, [pedidoEstate]);


    const resetScrollPosition = useCallback(()=>{
        const el = document.getElementById("modal-detalhes-main-container")
        if (el) el.scrollIntoView()
    }, [])

    const handleChange = (newValue: number, counter: number) => {
        resetScrollPosition()
        setValueState(newValue + counter);
    };

    const handleClose = () => {
        modalDetalhesModel.setOpenModal(false);
    };

    const handleShowProposta = (origem: 'whatsapp' | 'visualizar') => {
        const temTodasPermissoes = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes) && PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)
        const origemUploads = projetoState?.uploads?.find(i => i?.origem === 'V1');

        const checarTipoProposta = () => {
            let tipoPropostaLocal: TiposVisualizacaoProposta = TiposVisualizacaoProposta.SIMPLIFICADA;
            let baixarProposta = false;
            let abrirModalSelecao = false;
            let abrirModalVisualizar = false;

            if (projetoState?.segmento === 'distribuicao_offgrid') {
                tipoPropostaLocal = TiposVisualizacaoProposta.SIMPLIFICADA
                abrirModalVisualizar = true;
            } else if (projetoState?.origem === 'V1' && projetoState?.uploads?.length === 1 && origemUploads) {
                tipoPropostaLocal = origemUploads?.tipo?.includes('simplificada') ? TiposVisualizacaoProposta.SIMPLIFICADA : TiposVisualizacaoProposta.DETALHADA;
                abrirModalVisualizar = true;
            } else if (!!projetoState?.tipo && !["dimensionado"].includes(projetoState.tipo)) {
                switch (projetoState?.tipo) {
                    case "avulso":
                        tipoPropostaLocal = TiposVisualizacaoProposta.SIMPLIFICADA
                        abrirModalVisualizar = true;
                        break;
                    case "vertical":
                        tipoPropostaLocal = buscaTipoDePropostaDeAcordoComPermissao(permissoes);
                        abrirModalVisualizar = true;
                        break;
                    case "personalizado":
                        if (projetoState.tipo_faturamento !== 'cliente' || projetoState?.codigo_venda?.includes("HIBRI")) {
                            tipoPropostaLocal = TiposVisualizacaoProposta.SIMPLIFICADA
                            abrirModalVisualizar = true;
                            break;
                        }
    
                        if (temTodasPermissoes) {
                            baixarProposta = false;
                            abrirModalSelecao = true
                        } else {
                            tipoPropostaLocal = buscaTipoDePropostaDeAcordoComPermissao(permissoes);
                            abrirModalVisualizar = true
                        }
    
                        break;
                    case "kit":
                        const kit = kits && Array.isArray(kits) ? kits[0] : kits;
                        const escolheuDetalhada = projetoState?.tipo_proposta_envio === 'detalhada'
    
                        if (kit?.itens?.length === 1 && kit?.itens[0]?.quantidade === 1 && escolheuDetalhada) {
                            if (temTodasPermissoes) {
                                baixarProposta = false;
                                abrirModalSelecao = true;
                            } else {
                                tipoPropostaLocal = buscaTipoDePropostaDeAcordoComPermissao(permissoes);
                                abrirModalVisualizar = true;
                            }
                        } else {
                            tipoPropostaLocal = TiposVisualizacaoProposta.SIMPLIFICADA;
                            abrirModalVisualizar = true;
                        }
                        break;
                }
            } else {
                if(projetoState?.codigo_venda?.includes("HIBRI")){
                    tipoPropostaLocal = TiposVisualizacaoProposta.SIMPLIFICADA
                    abrirModalVisualizar = true
                } else if (temTodasPermissoes) {
                    baixarProposta = false;
                    abrirModalSelecao = true;
                } else {
                    tipoPropostaLocal = buscaTipoDePropostaDeAcordoComPermissao(permissoes);
                    abrirModalVisualizar = true;
                }
            }

            return {
                tipoPropostaLocal,
                baixarProposta,
                abrirModalSelecao,
                abrirModalVisualizar
            }
        }

        const { abrirModalSelecao, abrirModalVisualizar, baixarProposta, tipoPropostaLocal } = checarTipoProposta()

        setBaixarProposta(baixarProposta);
        
        if (origem !== 'whatsapp') {
            if (abrirModalVisualizar) {
                setTipoVisualizacaoProposta(tipoPropostaLocal);
                setOpenModalVisualizarProposta(true);
            }
        }

        if (abrirModalSelecao) {
            setTipoPropostaModalIsOpened({ status: true, origem })
        }

        return abrirModalSelecao ? '' : tipoPropostaLocal
    };

    const handleOpenModalVisualizarProposta = (openModal:boolean) => {
        setOpenModalVisualizarProposta(openModal);
    }

    const handleOpenModalBaixarProposta = (openModal:boolean) => {
        setOpenModalBaixarProposta(openModal);
    }

    const getHistoricoProjeto = useCallback(async () => {
        if (!projetoState || projetoState?.origem === "V2") return [];

        const request: IDataRequest = {
            url: `/historicos/projetos/migrados?projeto_id=${projetoState?.id}`,
        }
        const response = await apiNoLoading.get(request);

        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }

        const historicos = projetoState?.historicos_migrado || response?.data || [];
        const filterProjetos = historicos?.filter((i:any) => i?.nome_tabela === 'Projetos');
        const projetos = arraySort(filterProjetos, 'realizado_em', 'date');
        const entregas: any[] = [];
        projetos?.forEach(i => {
            const find = entregas?.find(ii => ii.descricao === i?.valores.DescricaoStatusPedido)
            if (i?.valores.DescricaoStatusPedido && !find) {
                entregas.push({
                    data: i?.realizado_em || '-',
                    descricao: i?.valores.DescricaoStatusPedido || '-'
                })
            }
        })

        setHistoricosProjeto(entregas);
    }, [projetoState]);

    let projeto_id = modalDetalhesModel?.projetoId;

    const carregarProjeto = async (projeto_id: number) => {
        await adminStore.getProjeto(projeto_id).then((resp) => {    
                setProjetoState(resp[0]);

                setKits(resp[0]?.carrinho && resp[0]?.carrinho.length ? resp[0]?.carrinho[0] : undefined);

                if(resp[0]?.pedido_erp_historicos){
                    const historico = resp[0]?.pedido_erp_historicos.sort(CollectionUtil.singleSort("-data_evento"));

                    setPedidoHistoricosErp(historico);
                    if(historico && historico.length){
                        setPedidoLinhaHistoricosErp(historico[0]);
                    }
                }

                if(resp[0]?.pedidos && resp[0]?.pedidos.length){

                    const pedido = resp[0].pedidos[0];

                    setPedido(pedido);

                    const notificacoes: PagamentoNotificacao[] = pedido?.notificacoes?.length > 0 ? pedido?.notificacoes : []
                    if (notificacoes.length > 0) {
                        notificacoes.sort(CollectionUtil.singleSort("-data_envio"))
                    }
                    setPedidoNotificacoes(notificacoes)

                    let pagamentos_historico = pedido?.pagamentos_historico;
                    if (pedido?.dados_pagamentos_migrado && pedido?.dados_pagamentos_migrado?.length) {
                        pagamentos_historico = pedido?.dados_pagamentos_migrado;
                    }

                    if(pagamentos_historico && pagamentos_historico.length){
                        pagamentos_historico.sort(CollectionUtil.singleSort("-data_atualizacao_pagamento"));
                    }
                    
                    setPagamentoHistorico(pagamentos_historico);
                    if(pagamentos_historico && pagamentos_historico.length){
                        setPagamentoHistoricoLinha([pagamentos_historico[0]]);
                    }
                }

                modalDetalhesModel.setOpenModal(true);
            })
    }

    const handleReenviarEmailPagamento = async () => {
        if (!pedidoEstate || !projetoState) return;

        setIsLoading(true);
        const request: IDataRequest = {
            url: `/projetos/reenviar_email_pagamento`,
            data: {
                codigo_venda: pedidoEstate.codigo_venda
            }
        }
        const response: IDataResponse = await api.post(request);

        if (response.statusCode === STATUS_CODE.OK) {
            await carregarProjeto(projeto_id || 0);
            setCopiedPagamento({exibir: true, erro: false, texto: 'E-mail enviado com sucesso', email: true});
            setTimeout(()=>{setCopiedPagamento({exibir: false, erro: false, texto: ''})},900)
        } else {
            setCopiedPagamento({exibir: true, erro: true, texto: 'Erro ao reenviar e-mail', email: true});
            setTimeout(()=>{setCopiedPagamento({exibir: false, erro: false, texto: ''})},900)
        }
        setIsLoading(false);
    }

    useEffect(() => {
        if (projeto_id) {
            carregarProjeto(projeto_id);
        }
    }, [projeto_id]);

    useEffect(()=>{
        if (projeto_id) {
            adminStore.getProjeto(projeto_id, true).then((resp) => {
                setProjetoState(resp[0]);

                setKits(resp[0]?.carrinho && resp[0]?.carrinho.length ? resp[0]?.carrinho : []);

                if(resp[0]?.pedido_erp_historicos){
                    const historico = resp[0]?.pedido_erp_historicos.sort(CollectionUtil.singleSort("-data_evento"));
                    
                    setPedidoHistoricosErp(historico);
                    if(historico && historico.length){
                        setPedidoLinhaHistoricosErp(historico[0]);
                    }
                }

                if(resp[0]?.pedidos && resp[0]?.pedidos.length){
                    const pedido = resp[0].pedidos[0];
                    setPedido(pedido);

                    const notificacoes: PagamentoNotificacao[] = pedido?.notificacoes?.length > 0 ? pedido?.notificacoes : []
                    if (notificacoes.length > 0) {
                        notificacoes.sort(CollectionUtil.singleSort("-data_envio"))
                    }
                    setPedidoNotificacoes(notificacoes)

                    let pagamentos_historico = pedido?.pagamentos_historico;
                    if (pedido?.dados_pagamentos_migrado && pedido?.dados_pagamentos_migrado?.length) {
                        pagamentos_historico = pedido?.dados_pagamentos_migrado;
                    }

                    if(pagamentos_historico && pagamentos_historico.length){
                        pagamentos_historico.sort(CollectionUtil.singleSort("-data_atualizacao_pagamento"));
                    }

                    setPagamentoHistorico(pagamentos_historico);
                    if(pagamentos_historico && pagamentos_historico.length){
                        setPagamentoHistoricoLinha([pagamentos_historico[0]]);
                    }
                }
            })
        }
    },[refreshState])

    function formatData(data: any, type: string = "DD/MM/YYYY - HH:mm:ss"): string {
        if (!data) return "";
        if (String(data)?.includes("GMT")) {
            return moment(data).utc().format(type);
        }
        return moment(data).format(type);
    }

    function getNomeFormaPagamento(id:string): string {
        switch (id) {
            case "boleto":
                return "Boleto";
            case "cartao_credito":
                return "Cartão de Crédito";
            case "financiamento":
                return "Financiamento";
            case "carta_credito":
                return "Financiamento Indireto";
            case "boleto_cartao_credito":
                return "Boleto e Cartão de Crédito";
            case "boleto_financiamento":
                return "Boleto e Financiamento";
            case "cartao_credito_financiamento":
                return "Cartão de Crédito e Financiamento";
            case "pix":
                return "Pix";
            case "pix_cartao_credito":
                return "Pix e Cartão de Crédito";
            case "boleto_financiamento_indireto":
                return "Boleto e Financiamento Indireto";
            case "cartao_credito_financiamento_indireto":
                return "Cartão de Crédito e Financiamento Indireto";
            case "pix_financiamento":
                return "Pix e Financiamento";
            case "pix_financiamento_indireto":
                return "Pix e Financiamento Indireto";        
            case "finame":
                return "FINAME";
            default:
                return "";
        }
    }

    function getFormaPagamento(id:number): string {
        switch (id) {
            case 1:
                return "boleto";
            case 2:
                return "cartao_credito";
            case 3:
                return "financiamento";
            case 4:
                return "carta_credito";
            case 5:
                return "boleto_cartao_credito";
            case 6:
                return "boleto_financiamento";
            case 7:
                return "cartao_credito_financiamento";
            case 8:
                return "pix";
            case 9:
                return "pix_cartao_credito";
            case 10:
                return "boleto_financiamento_indireto";
            case 11:
                return "cartao_credito_financiamento_indireto";
            case 12:
                return "pix_financiamento";
            case 13:
                return "pix_financiamento_indireto";        
            case 14:
                return "finame";
            default:
                return "";
        }
    }
    function getFinanceiraV1(pagamento: any):string {
        // BVFINANCEIRA: { value: 0, label: 'BV', img: '/img/bv-financeira.png' },
        // SANTANDER: { value: 1, label: 'Santander', img: '/img/santander.png' },
        // AILOS: { value: 3, label: 'Ailos', img: '/img/ailos.png' },
        // OUTRA: { value: 2, label: 'Outra', img: '/img/Outra.png' },
        // CRESOL: { value: 4, label: 'Cresol', img: '/img/cresol.png' },
        // UNICRED: { value: 5, label: 'Unicred', img: '/img/unicred.png' },
        // SOLFACIL: { value: 6, label: 'Solfácil', img: '/img/solfacil.png' },
        // MILENIO: { value: 7, label: 'Milenio', img: '/img/Outra.png' },
        
        let financeira = "";
        const id = pagamento?.Financeira >= 0 ? Number(pagamento?.Financeira) : null;
        if (id !== null) {
            switch (id) {
                case 0:
                    financeira = "BV"
                    break;
                case 1:
                    financeira = "Santander"
                    break;
                case 2:
                    financeira = "Outra"
                    break;
                case 3:
                    financeira = "Ailos"
                    break;
                case 4:
                    financeira = "Cresol"
                    break;
                case 5:
                    financeira = "Unicred"
                    break;
                case 6:
                    financeira = "Solfácil"
                    break;
                case 7:
                    financeira = "Milenio"
                    break;
                default:
                    break;
            }
        }

        return financeira;
    }
    function getBandeiraV1(pagamento: any):string {
        // AMERICANEXPRESS: { value: 0, label: 'Amex', chave: 'AMEX', img: '/img/cartoes/AMEX.png' },
        // MASTERCARD: { value: 1, label: 'MasterCard', chave: 'MASTERCARD', img: '/img/cartoes/MASTERCARD.png' },
        // VISA: { value: 2, label: 'Visa', chave: 'VISA', img: '/img/cartoes/VISA.png' },
        // DINERS: { value: 3, label: 'Diners Club', chave: 'DINERSCLUB', img: '/img/cartoes/DINERSCLUB.png' },
        // JCB: { value: 4, label: 'JCB', chave: 'JCB', img: '/img/cartoes/JCB.png' },
        // OUTRA: { value: 5, label: 'Outra', chave: 'OUTRA', img: '/img/cartao-icon.png' },
        // HIPERCARD: { value: 6, label: 'Hipercard', chave: 'HIPERCARD', img: '/img/cartao-icon.png' },
        // ELO: { value: 7, label: 'Elo', chave: 'ELO', img: '/img/cartao-icon.png' },

        // BandeiraCartao

        let bandeira = "";
        const id = pagamento?.BandeiraCartao >= 0 ? Number(pagamento?.BandeiraCartao) : null;
        if (id !== null) {
            switch (id) {
                case 0:
                    bandeira = "Amex"
                    break;
                case 1:
                    bandeira = "MasterCard"
                    break;
                case 2:
                    bandeira = "VISA"
                    break;
                case 3:
                    bandeira = "Diners Club"
                    break;
                case 4:
                    bandeira = "JCB"
                    break;
                case 5:
                    bandeira = "Outra"
                    break;
                case 6:
                    bandeira = "Hipercard"
                    break;
                case 7:
                    bandeira = "ELO"
                    break;
                default:
                    break;
            }
        }

        return bandeira;
    }
    
    const getHistoricoNotaFiscal = useCallback(async (numero) => {
        if (!pedidoEstate || !numero) return [];
        setLoadingNf(true);
    
        const request: IDataRequest = {
            url: `/historicos/pedidos/migrados/notas_fiscais?pedido_id=${pedidoEstate?.id}&numero_nota_fiscal=${numero}&includes=itens`,
        }
        const response = await apiNoLoading.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            return;
        }
    
        const dados = response.data;
        const historicos = arraySort(dados, 'realizado_em', 'date');
        const result = historicos?.map((i: any) => ({
            numero: Number(i?.valores?.NumeroNotaFiscal || 0),
            valor: Number(i?.valores?.ValorTotal || 0),
            created_at: i?.realizado_em,
            data_criacao: i?.realizado_em,
            itens: uniqBy(i?.itens?.map((item: any) => ({
                codigo: item?.valores?.CodigoProduto,
                nome: item?.valores?.NomeProduto,
                quantidade: Number(item?.valores?.Quantidade) || 1,
                valor: Number(item?.valores?.ValorTotal) || 0,
            })) || [], 'codigo'),
    
            peso_bruto: Number(i?.valores?.PesoBruto || 0),
            observacao: i?.valores?.Observacao || "",
            
            cidade: i?.valores?.EnderecoEntregaHistorico?.Cidade || "",
            estado: i?.valores?.EnderecoEntregaHistorico?.Estado || "",
            uf: i?.valores?.EnderecoEntregaHistorico?.UF || "",
            cep: i?.valores?.EnderecoEntregaHistorico?.CEP || "",
            bairro: i?.valores?.EnderecoEntregaHistorico?.Bairro || "",
            logradouro: i?.valores?.EnderecoEntregaHistorico?.Logradouro || "",
            number: i?.valores?.EnderecoEntregaHistorico?.Number || "",
            complemento: i?.valores?.EnderecoEntregaHistorico?.Complemento || "",
        }));
    
        setNFHistorico(result?.sort(CollectionUtil.singleSort("-data_criacao")))
        setNFHistoricoLinha(result[0])
        setLoadingNf(false);
    }, [pedidoEstate]);

    useEffect(() => {
        if(pedidoEstate){
           if (projetoState?.origem === 'V1') {
                getHistoricoProjeto();

                const historicoNfMigrado = pedidoEstate?.notas_fiscais
                    ?.sort(CollectionUtil.singleSort("-data_criacao"))
                    ?.filter((i:any) => i?.situacao === "ativa" && i?.origem === "venda")[0];
                getHistoricoNotaFiscal(historicoNfMigrado?.numero);
           } else {
               adminStore.getNFHistorico(pedidoEstate?.id, true).then((resp) => {
                   setNFHistorico(resp)
               });
           }
        }
    }, [pedidoEstate, projetoState?.origem, getHistoricoNotaFiscal])

    useEffect(() => {
        setNFShowLinha(nfHistoricoLinhaEstate || pedidoEstate?.notas_fiscais?.[0])
    }, [pedidoEstate, nfHistoricoLinhaEstate])

    useEffect(() => {
        setPedidoShowHistoricosErp(pedidoLinhaHistoricosErp || pedidoHistoricosErp[0])

        if(pedidoLinhaHistoricosErp || pedidoHistoricosErp[0]){
            const getCategoriaIdsByGrupo = (grupo: TCategoriasComponentes['grupo']): number[] => categoriasComponentes?.data?.filter(c => c.grupo === grupo)?.map(c => c.id) || [];
            const CategoriasEstruturasIds   = getCategoriaIdsByGrupo('itens_estrutura');
            const CategoriasAcessoriosIds  = getCategoriaIdsByGrupo('acessorios');
            const CategoriasInversoresIds  = getCategoriaIdsByGrupo('inversores');
            const CategoriasModulosIds     = getCategoriaIdsByGrupo('modulos');
            const CategoriasBateriasIds    = getCategoriaIdsByGrupo('baterias');
            const CategoriasControladoresIds = getCategoriaIdsByGrupo('controladores');
            const CategoriasIluminacaoIds  = getCategoriaIdsByGrupo('iluminacao');

            const componentes: TPedidosHistoricosComponentes[] = pedidoLinhaHistoricosErp?.itens || pedidoHistoricosErp?.[0].itens;

            const estruturas = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasEstruturasIds.includes(rec.categoria_componentes_id));
            const acessorios = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasAcessoriosIds.includes(rec.categoria_componentes_id));
            const inversores = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasInversoresIds.includes(rec.categoria_componentes_id));
            const modulos = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasModulosIds.includes(rec.categoria_componentes_id));
            const baterias = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasBateriasIds.includes(rec.categoria_componentes_id));
            const controladores = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasControladoresIds.includes(rec.categoria_componentes_id));
            const iluminacao = componentes.filter((rec: TPedidosHistoricosComponentes) => CategoriasIluminacaoIds.includes(rec.categoria_componentes_id));

            setEstruturasPedidosHistoricosState(estruturas);
            setAcessoriosPedidosHistoricosState(acessorios);
            setInversoresPedidosHistoricosState(inversores);
            setModulosPedidosHistoricosState(modulos);
            setBateriasPedidosHistoricosState(baterias);
            setControladoresPedidosHistoricosState(controladores);
            setIluminacaoPedidosHistoricosState(iluminacao);
        }
    }, [pedidoHistoricosErp, pedidoLinhaHistoricosErp])

    const valor_liquido_revenda = (projetoState?.valor_servico || 0) + (projetoState?.valor_margem_produtos || 0)

    const userInfo = LocalStorage.get("solar.userExtraInfo", true);

    let hashCodVenda = ''

    if (projetoState?.url_pagamento){

        const _tokenApi = LocalStorage.get("solar.token");
        if (_tokenApi) {
            const decoded: any = jwtDecode(_tokenApi);
            const _tokenPagamento = {
                cnpj_cpf: decoded.user.cnpjCpf,
                token: decoded.token,
                refresh_token: decoded.refreshToken,
                type: decoded.type,
                customContaUnica: decoded.customContaUnica,
                clientType: 'representante'
            }

            hashCodVenda = projetoState?.url_pagamento + jwt.encode(_tokenPagamento, process.env.REACT_APP_TOKEN_KEY || "");
        }
    }

    const getRodapeTabelaProdutos = (valorTotal?: number) => {
        if (!userInfo?.isIntelbras) return <div />
        let colSpanTotalProdutos = 2;
        let colSpanValorTotal = 5;
        const visualizarCodigoComponente = getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE);
        const visualizarFator = getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_FATOR);
        const visualizarValores =  getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES)

        if (visualizarCodigoComponente) {
            if (visualizarFator) {
                // t t t
                if (!visualizarValores) {
                    colSpanValorTotal = 2;  // t t f
                }
            } else if (visualizarValores) {
                colSpanValorTotal = 4;  // t f t
            } else {
                colSpanValorTotal = 3;  // t f f
            }
        } else if (visualizarFator) {
            if (visualizarValores) {
                colSpanValorTotal = 4;  // f t t
            } else {
                colSpanTotalProdutos = 1; colSpanValorTotal = 2;  // f t f
            }
        } else if (visualizarValores) {
            colSpanValorTotal = 3;  // f f t
        } else {
            colSpanTotalProdutos = 1; colSpanValorTotal = 1;  // f f f
        }

        /*
        if(kits?.itens[0]?.fator && valorTotal){
            valorTotal = valorTotal * kits?.itens[0]?.fator;
        }
        */

        return isMobile 
        ? (
            <>
                <Typography  className={classes.principal} variant="h5" component="h2">
                    Total de produtos:
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                    {Formater.toString(valorTotal, TypeRecords.CURRENCY)}
                </Typography>
            </>
        ) : (
            <>
                <TableCell colSpan={colSpanTotalProdutos} align="left" className={classes.principal}>Total de produtos</TableCell>
                <TableCell colSpan={colSpanValorTotal + 1} align="right" className={classes.principal}>
                    {Formater.toString(valorTotal, TypeRecords.CURRENCY)}
                </TableCell>
            </>
        )
    }

    const getPermissao = useCallback((permissao: string)=>{
        return PermissionUtil.can(permissao, permissoes); 
    },[permissoes, kits])

    const getEnderecoCliente = () => {
        if (avulso) return projetoState?.estado_id;
        if (projetoV1 && projetoState?.endereco_proposta) return projetoState?.endereco_proposta?.replace('null,', '');
        if (!projetoState?.endereco?.logradouro && !projetoState?.endereco?.numero && !projetoState?.endereco?.cep && projetoState?.cidade?.nome) {
            return `${projetoState?.cidade?.nome || ''}/${projetoState?.cidade?.estado_id || ''}`;
        }
        return `${projetoState?.endereco?.logradouro + ' -' || ''} ${(projetoState?.endereco?.numero ? projetoState?.endereco?.numero : 'SN -') || 'SN'} ${projetoState?.endereco?.bairro + ' -' || ''} ${projetoState?.cidade?.nome || ''}/${projetoState?.cidade?.estado_id + ' -' || ''} ${Formater.toCEP(projetoState?.endereco?.cep) || ''}`
    }

    const getEnderecoDistribuidor = () => {
        return `${projetoState?.distribuidor?.bairro || ''}  ${projetoState?.distribuidor?.logradouro ? ' - ' + projetoState?.distribuidor?.logradouro : ''} ${projetoState?.distribuidor?.cep ? ' - ' + Formater.toCEP(projetoState?.distribuidor?.cep) : ''}`
    }
    const getEnderecoRevenda = () => {
        return `${projetoState?.revenda?.bairro || '-'}  ${projetoState?.revenda?.logradouro ? ' - ' + projetoState?.revenda?.logradouro : ''} ${projetoState?.revenda?.cep ? ' - ' + Formater.toCEP(projetoState?.revenda?.cep) : ''}`
    }

    const situacaoDocumentacaoServico = useMemo(()=>{
        if (projetoState?.status_projeto !== 'finalizado') return 'Aguardando Finalização do Projeto'
        const DEFAULT_STATUS_VALUE = 'aguardando_documentacao'
        const status = STATUS_COMISSIONAMENTO.find(item => item.value === (projetoState?.status_comissionamento || DEFAULT_STATUS_VALUE))
        return status?.text
    },[projetoState])
    
    const mostrarBotaoVisualizarProposta = useMemo(()=>{
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes) && !PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)) return false;
        
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes) && projetoState?.tipo === 'personalizado') return false
        
        const quantidadeKits = kits?.itens && kits.itens.length ? kits.itens.reduce((acc, curr) => acc + curr.quantidade , 0) : 0
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes) && projetoState?.tipo === 'kit' && quantidadeKits > 1) return false
        
        return true;
    },[permissoes, projetoState, kits])
    
    const mostrarBotaoEnviarWhatsapp = useMemo(()=>{
        return PermissionUtil.can(PermissionUtil.PERMISSION_ENVIAR_MENSAGEM_WHATSAPP, permissoes) && projetoState?.tipo !== 'avulso';
    },[permissoes, projetoState])

    const validarExibicaoData = useCallback((dadosFormaPagamento: { situacao: string, data_pagamento: string }) => {
        if (dadosFormaPagamento?.situacao && ['expirado', 'cancelado', 'recusado'].includes(dadosFormaPagamento.situacao)) {
            return '-'
        }
        return validarData(dadosFormaPagamento.data_pagamento)
    }, [])

    const validarData = (data: any): String => {
        const formated = String(data)?.includes('T') ? String(data)?.replace('T', ' ')?.replace('Z', '') : data;
        return (data && !moment(formated).format("DD/MM/YYYY")?.includes('01/01/0001')) ? moment(formated).format("DD/MM/YYYY - HH:mm") : '-'
    }

    const renderBoleto = (dados: any): ReactNode => {
        const boleto = dados?.boleto?.sort((a: any, b: any) => {
            return Date.parse(a?.created_at || a?.data_vencimento) - Date.parse(b?.created_at || b?.data_vencimento)
        });
        const dadosBoleto = boleto?.length ? boleto?.slice(-1) : [];
        return (
            <>
                {dadosBoleto?.map((c: any) => {
                    return <>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box component={"h4"}>Boleto</Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data de Pagamento:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarExibicaoData(c)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('boleto', dados, c.situacao)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>;
                })}
            </>
        )
    }
    const renderVarejo = (dados: any): ReactNode => {
        const varejo = dados?.varejo?.sort((a: any, b: any) => {
            return Date.parse(a?.created_at || a?.data_pagamento) - Date.parse(b?.created_at || b?.data_pagamento)
        });
        const dadosVarejo = varejo?.length ? varejo?.slice(-1) : [];
        return (
            <>
                {dadosVarejo?.map((c: any) => {
                    return <>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box component={"h4"}>Varejo</Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data de Pagamento:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarExibicaoData(c)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('varejo', dados, c.situacao)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>;
                })}
            </>
        )
    }
    const renderCartaoCredito = (dados: any): ReactNode => {
        const cartao = dados?.cartao_credito?.sort((a: any, b: any) => {
            return Date.parse(a?.created_at || a?.data_pagamento) - Date.parse(b?.created_at || b?.data_pagamento)
        });
        const dadosCartao = !FORMAS_PAGAMENTO_UNICO.includes(formaPagamentoId) ? cartao?.slice(-1) : dados?.cartao_credito;
        if (!dadosCartao?.length) return (<></>);
        return (
            <>
                <Grid container size={12}>
                        <Grid size={12}>
                            <Box component={"h4"}>{dadosCartao?.length === 1 ? 'Cartão de' : 'Cartões'} Crédito</Box>
                        </Grid>
                    {dadosCartao?.map((c: any, index: number) => {
                        return <>
                            {dadosCartao?.length > 1 ? (
                                <Grid size={12}>
                                    <Box component={"h4"}>{`Cartão ${index + 1}`}</Box>
                                </Grid>
                            ): ("")}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data do Pagamento:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarData(c.data_pagamento)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('cartao_credito', dados, c.situacao, index)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Bandeira:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {c.bandeira ? c.bandeira : '-'}
                                </Typography>
                            </Grid>
                            
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Parcelas:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {c.parcelas || "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor parcela:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor / (c.parcelas || 1), TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </>;
                    })}
                </Grid>
            </>
        )
    }
    const renderFinanciamento = (dados: any): ReactNode => {
        return (
            <>
                {dados?.financiamento?.map((f: any) => {
                    return <>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box component={"h4"}>Financiamento</Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data de conclusão da análise:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarData(f.data_pagamento)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Financeira:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {f.financeira || '-'}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Parcelas:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {f.parcelas || '-'}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('financiamento', dados, f.situacao)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Taxa:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {(f.taxa && Formater.toString(f.taxa, TypeRecords.PERCENT2)) || '-'}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(f.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>
                })}
            </>
        )
    }
    const renderCartaCredito = (dados: any): ReactNode => {
        return (
            <>
                {dados?.carta_credito?.map((c: any) => {
                    return <>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box component={"h4"}>Financiamento Indireto</Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data de conclusão da análise:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarData(c.data_pagamento)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Financeira:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {c.banco_nome || '-'}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('carta_credito', dados, c.situacao)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>
                })}
            </>
        )
    }
    const renderPix = (dados: any): ReactNode => {
        const pix = dados?.pix?.sort((a: any, b: any) => {
            return Date.parse(a?.created_at || a?.data_expiracao) - Date.parse(b?.created_at || b?.data_expiracao)
        });
        const dadosPix = pix?.length ? pix?.slice(-1) : [];
        return (
            <>
                {dadosPix?.map((c: any) => {
                    return <>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box component={"h4"}>Pix</Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Data de Pagamento:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {validarExibicaoData(c)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Situação:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {renderSituacaoPagamentoHistorico('pix', dados, c.situacao)}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(c.valor, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>;
                })}
            </>
        )
    }

    const renderPagamentoCombinado = (dados_migracao: any, historico: any): ReactNode => {
        let dados = {...dados_migracao};

        if (!dados?.migracao || !historico) return (<></>);

        if (dados?.migracao?.pagamento) {
            const dados_migracao = dados?.migracao || historico?.dados_migracao;
            const pagamento = dados_migracao?.pagamento;

            if (pagamento?.boleto) {
                dados.boleto = pagamento?.boleto?.map((boleto: any) => ({
                    valor: boleto?.Valor,
                    situacao: historico?.situacao,
                    data_pagamento: boleto?.DataPagamento,
                    parcelas: boleto?.Parcelas || 0,
                    observacao: boleto?.Observacao || "",
                    bandeira: getBandeiraV1(boleto) || "",
                    financeira: getFinanceiraV1(boleto) || "",
                    taxa: Number(boleto?.TaxaAprovada) || 0,
                    forma_pagamento_id: historico?.forma_pagamento_id,
                    etapa_financiamento: "",
                }))
            }
            if (pagamento?.cartao_credito) {
                dados.cartao_credito =  pagamento?.cartao_credito?.map((cartao_credito: any) => ({
                    valor: cartao_credito?.Valor,
                    situacao: historico?.situacao,
                    data_pagamento: cartao_credito?.DataPagamento,
                    parcelas: cartao_credito?.Parcelas || 0,
                    observacao: cartao_credito?.Observacao || "",
                    bandeira: getBandeiraV1(cartao_credito) || "",
                    financeira: getFinanceiraV1(cartao_credito) || "",
                    taxa: Number(cartao_credito?.TaxaAprovada) || 0,
                    forma_pagamento_id: historico?.forma_pagamento_id,
                    etapa_financiamento: "",
                }))
            }
            if (pagamento?.financiamento) {
                dados.financiamento =  pagamento?.financiamento?.map((financiamento: any) => ({
                    valor: financiamento?.Valor,
                    situacao: historico?.situacao,
                    data_pagamento: financiamento?.DataPagamento,
                    parcelas: financiamento?.Parcelas || 0,
                    observacao: financiamento?.Observacao || "",
                    bandeira: getBandeiraV1(financiamento) || "",
                    financeira: getFinanceiraV1(financiamento) || "",
                    taxa: Number(financiamento?.TaxaAprovada) || 0,
                    forma_pagamento_id: historico?.forma_pagamento_id,
                    etapa_financiamento: "",
                }))
            }
            if (pagamento?.pix) {
                dados.pix = pagamento?.pix?.map((pix: any) => ({
                    valor: pix?.Valor,
                    situacao: historico?.situacao,
                    data_pagamento: pix?.DataPagamento,
                    parcelas: pix?.Parcelas || 0,
                    observacao: pix?.Observacao || "",
                    bandeira: getBandeiraV1(pix) || "",
                    financeira: getFinanceiraV1(pix) || "",
                    taxa: Number(pix?.TaxaAprovada) || 0,
                    forma_pagamento_id: historico?.forma_pagamento_id,
                    etapa_financiamento: "",
                }))
            }

            return (
                <>
                    {dados?.boleto && renderBoleto(dados)}
                    {dados?.cartao_credito && renderCartaoCredito(dados)}
                    {dados?.financiamento && renderFinanciamento(dados)}
                    {dados?.pix && renderPix(dados)}
                </>
            )
        }
    }

    const parseNomePagamentoV1 = (dados: any): ReactNode => {
        const formaPagamento = getFormaPagamento(dados?.forma_pagamento_id);
        if (formaPagamento) return getNomeFormaPagamento(formaPagamento);
        return "";
    }

    const formaPagamentoId = useMemo(() => {
        const pedidoFormaPagametoId = pedidoEstate?.forma_pagamento?.id;
        const pagamentoUnicoId = pedidoEstate?.pagamentos?.length === 1 && pedidoEstate?.pagamentos[0]?.forma_pagamento?.id;
        const pagamentoHistorico = pedidoEstate?.pagamentos_historico || []
        const ultimoHistorico = pagamentoHistorico[pagamentoHistorico.length - 1]
        return pedidoFormaPagametoId || pagamentoUnicoId || ultimoHistorico?.forma_pagamento_id;
    }, [pedidoEstate])

    const parseDadosIntegracaoHistorico = (dados_integracao: any, historico: any): ReactNode => {
        let dados = {...dados_integracao};

        const pixPago = dados?.pix?.filter((item: any) => item.data_pagamento) || null
        if (pixPago?.length) dados.pix = pixPago

        const financiamentoPago = dados?.financiamento?.filter((item: any) => item.data_pagamento) || null
        if (financiamentoPago?.length) dados.financiamento = financiamentoPago

        const boletoPago = dados?.boleto?.filter((item: any) => item.data_pagamento) || null
        if (boletoPago?.length) dados.boleto = boletoPago

        const cartaCreditoPago = dados?.carta_credito?.filter((item: any) => item.data_pagamento) || null
        if (cartaCreditoPago?.length) dados.carta_credito = cartaCreditoPago
        
        const cartaoCreditoPago = dados?.cartao_credito?.filter((item: any) => item.data_pagamento) || null
        if (cartaoCreditoPago?.length) dados.cartao_credito = cartaoCreditoPago

        if (dados?.migracao) {
            if (historico) {
                const dados_migracao = dados?.migracao || historico?.dados_migracao;
                const name = getFormaPagamento(historico?.forma_pagamento_id);
                dados = {[`${name}`]: [{
                    valor: historico?.valor,
                    situacao: historico?.situacao,
                    data_pagamento: historico?.data_criacao_pagamento || dados_migracao?.pagamento?.DataPagamento,
                    parcelas: dados_migracao?.pagamento?.Parcelas || 0,
                    observacao: dados_migracao?.pagamento?.Observacao || "",
                    bandeira: getBandeiraV1(dados_migracao?.pagamento) || "",
                    financeira: getFinanceiraV1(dados_migracao?.pagamento) || "",
                    taxa: Number(dados_migracao?.pagamento?.TaxaAprovada) || 0,
                    forma_pagamento_id: historico?.forma_pagamento_id,
                    pagamento_combinado: dados_migracao?.pagamento,
                    etapa_financiamento: "",
                }]}
            }
        }

        if (formaPagamentoId && FORMAS_PAGAMENTO_UNICO?.includes(formaPagamentoId)) {
            switch (formaPagamentoId) {
                case FORMA_PAGAMENTO_BOLETO:
                    if (dados?.boleto?.length) return <>{renderBoleto(dados)}</>
                    break;
                case FORMA_PAGAMENTO_CARTAO_CREDITO:
                    if (dados?.cartao_credito?.length) return <>{renderCartaoCredito(dados)}</>
                    break;
                case FORMA_PAGAMENTO_FINANCIAMENTO:
                    if (dados?.financiamento?.length) return <>{renderFinanciamento(dados)}</>
                    break;
                case FORMA_PAGAMENTO_CARTA_CREDITO:
                    if (dados?.carta_credito?.length) return <>{renderCartaCredito(dados)}</>
                    break;
                case FORMA_PAGAMENTO_PIX:
                    if (dados?.pix?.length) return <>{renderPix(dados)}</>
                    break;
                case FORMA_PAGAMENTO_VAREJO:
                    if (dados?.varejo?.length) return <>{renderVarejo(dados)}</>
                    break;
            }
        }

        if (!!dados?.boleto?.length || !!dados?.pix?.length || !!dados?.cartao_credito?.length || !!dados?.carta_credito?.length || !!dados?.financiamento?.length) {
            return (
                <>
                    {!!dados?.boleto?.length && renderBoleto(dados)}
                    {!!dados?.pix?.length && renderPix(dados)}
                    {!!dados?.cartao_credito?.length && renderCartaoCredito(dados)}
                    {!!dados?.carta_credito?.length && renderCartaCredito(dados)}
                    {!!dados?.financiamento?.length && renderFinanciamento(dados)}   
                    {!!dados?.varejo?.length && renderVarejo(dados)}    
                </>
            )
        } else {
            return renderPagamentoCombinado(dados_integracao, historico);
        }
    }

    const hibrido = useMemo(() => {
        if (!projetoState?.codigo_venda) return false;
        return isHibrido(projetoState.codigo_venda, projetoState?.tipo);
    }, [projetoState?.codigo_venda, projetoState?.tipo]);

    const renderProductPedidoRow = useCallback((row: TPedidosHistoricosComponentes) => {
        return (
            <Typography className={classes.pos}>
                <b>Código:</b> {getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE) ? row?.componente_id : "-"} <br/>
                <b>Nome:</b> {row?.nome} <br/>
                <b>Quantidade:</b> {row.quantidade}
            </Typography>
        )
    }, [getPermissao]);


    const listaComponentes = useMemo(() => {
        const categorias = categoriasComponentes?.data || [];
        const itens = projetoState?.componentes || [];
        return itens?.map(item => {
            const categoria = categorias?.find(i => i?.id === item?.componente?.categoria_componentes_id);
            return {
                ...item,
                nome_categoria: categoria?.nome || "",
                grupo_categoria: categoria?.grupo || "",
                ordem_listagem: categoria?.ordem_listagem || item?.componente?.categoria_componentes_id,
            }
        })?.sort((a, b) => {
            const pesoGrupoA = ORDEM_GRUPO_CATEGORIAS[a.grupo_categoria as TGrupoCategoria] || a?.componente?.categoria_componentes_id;
            const pesoGrupoB = ORDEM_GRUPO_CATEGORIAS[b.grupo_categoria as TGrupoCategoria] || b?.componente?.categoria_componentes_id;
    
            if (pesoGrupoA !== pesoGrupoB) {
                return pesoGrupoA - pesoGrupoB;
            }
    
            return a.ordem_listagem - b.ordem_listagem;
        });
    }, [projetoState?.componentes, categoriasComponentes]);

    const renderProductRow = (row: ComponenteProjeto, avulso?: boolean)=>{
        return (
            <TableRow key={row?.componente_id}>
                { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE) &&
                    <TableCell component="th" scope="row">
                        {row?.componente?.id}
                    </TableCell>
                }
                <TableCell component="th" scope="row">
                    {row?.componente?.nome}
                </TableCell>
                <TableCell align="center">{row.quantidade}</TableCell>
                { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_FATOR) && (
                    <>
                        { (projetoState?.origem === "V1" && !!row?.dados_migracao) ? (
                            <TableCell align="left">{(row?.dados_migracao?.FatorMultiplicacao || 1).toFixed(2)}</TableCell>
                        ) : (
                            <TableCell align="left">{Number(row.fator || 0).toFixed(2)}</TableCell>
                        )}
                    </>)
                }
                { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES) && 
                    <>
                        { (projetoState?.origem === "V1" && !!row?.dados_migracao) ? (
                                <TableCell align="left">{Formater.toString((row?.dados_migracao?.ValorOriginal || 0), TypeRecords.CURRENCY)}</TableCell>

                            ) : (
                                <TableCell align="left">{Formater.toString(row.valor_unitario_original, TypeRecords.CURRENCY)}</TableCell>
                            ) 
                        }
                        <TableCell align="left">{Formater.toString(row.valor_unitario, TypeRecords.CURRENCY)}</TableCell>
                        <TableCell align="left">{Formater.toString((kits?.itens && kits?.itens.length && kits?.itens[0]?.fator ? row.valor_unitario*row.quantidade : Number(row?.valor_unitario*row.quantidade).toFixed(2)), TypeRecords.CURRENCY)}</TableCell>
                    </>
                }
                <TableCell align="left">
                    <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                        <IconButton
                            onClick={() => row?.componente?.id && setModalComponentesDetalhesData(row.componente.id)}
                            size="large">
                            <FindInPageOutlined htmlColor="black" />
                        </IconButton>
                    </Box>
                </TableCell>
            </TableRow>
        );
    }

    const renderProductMobile = (row: ComponenteProjeto)=> {
        const showFator = getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_FATOR);
        const showValores = getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES);
        const showCodigoVenda = getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE);

        const fator = (projetoState?.origem === "V1" && !!row?.dados_migracao) 
            ? ((row?.dados_migracao?.FatorMultiplicacao || 1).toFixed(2)) 
            : (Number(row.fator || 0).toFixed(2));

        const valorOriginal = (projetoState?.origem === "V1" && !!row?.dados_migracao) 
                ? (row?.dados_migracao?.ValorOriginal || 0) 
                : (row.valor_unitario_original || 0);

        return (
            <Paper key={row?.componente_id} elevation={1} className="box-produtos">
                <Box display={"flex"} flexDirection="row" alignItems="center" justifyContent="space-between">
                    <Typography>
                        {(showCodigoVenda ? `${row?.componente?.id} - ` : "") + row?.componente?.nome}
                    </Typography>
                    <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                        <IconButton
                            onClick={() => row?.componente?.id && setModalComponentesDetalhesData(row.componente.id)}
                            size="large">
                            <FindInPageOutlined htmlColor="black" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider className="produtos-divider" />
                { showFator ? (
                    <>
                        <Grid container size={12} className="box-produtos-item">
                            <Grid size={6}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Quantidade
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {row.quantidade}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Fator
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {fator}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <Box className="box-produtos-row">
                        <Typography  className={classes.principal} variant="h5" component="h2" style={{ marginTop: 0 }}>
                            Quantidade
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary" style={{ marginBottom: 0 }}>
                            {row.quantidade}
                        </Typography>
                    </Box>
                )}
                { showValores && 
                    <>
                        <Grid container size={12} className="box-produtos-item">
                            <Grid size={6}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor Original
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    { Formater.toString(valorOriginal, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                            {showFator && (
                                <Grid size={6}>
                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                        Valor com Fator
                                    </Typography>
                                    <Typography className={classes.pos} color="textSecondary">
                                        { Formater.toString(valorOriginal * fator, TypeRecords.CURRENCY)}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid size={6}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor Final
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(row.valor_unitario, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Total Final
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString((kits?.itens && kits?.itens.length && kits?.itens[0]?.fator ? row.valor_unitario*row.quantidade : Number(row?.valor_unitario*row.quantidade).toFixed(2)), TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </>
                }
            </Paper>
        );
    }

    const renderResumo = (): ReactNode =>{
        return (<>        
            <Grid container size={12} className="modal-detalhes-tab-conteudo">
                <Grid size={12}>
                    <Box component={"h4"}>Dados</Box>
                </Grid>
                { projetoState?.tipo !== 'personalizado' &&   
                    <><Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Tensão:
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {inversorTensao}
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Fase:
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {tipoConexao}
                        </Typography>
                    </Grid></>
                }
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography className={classes.principal} variant="h5" component="h2">
                        Tipo de Inversor:
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {tipoInversor}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container size={12}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography  className={classes.principal} variant="h5" component="h2">
                        Potência do gerador (KWp): 
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {projetoState?.potencia}
                    </Typography>
                </Grid>
                {hibrido ?
                    (
                        <>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Tipo de Bateria:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {tipoBateria}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Tipo de pagamento:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {projetoState?.valor_servico ? 'Gerador com instalação': 'Apenas gerador sem instalação'}
                                </Typography>
                            </Grid>
                        </>
                    ) : (
                    <>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Preço kWh (R$):
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {Formater.toString(projetoState?.preco_kwh, TypeRecords.CURRENCY)}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Fator de perdas (%):
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {projetoState?.solucao_sugerida?.fator_perdas || '-'}
                            </Typography>
                        </Grid>
                    </>
                )}
            </Grid>
            <Grid container size={12}>
                {!hibrido && (
                    <>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Custo de operação:
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {Formater.toString(projetoState?.valor_anual_manutencao, TypeRecords.CURRENCY)}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Tipo de pagamento:
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {projetoState?.valor_servico ? 'Gerador com instalação': 'Apenas gerador sem instalação'}
                            </Typography>
                        </Grid>
                    </>
                )}
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography  className={classes.principal} variant="h5" component="h2">
                        Profissional de Vendas:
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {projetoState?.ev?.nome || '-'}
                    </Typography>
                </Grid>
                {!projetoState?.engenharia && (
                    <>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Peso do gerador (Kg)
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {Number(projetoState?.peso_gerador || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography  className={classes.principal} variant="h5" component="h2">
                                Peso do gerador no telhado (Kg)
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {Number(projetoState?.peso_telhado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Grid>
                    </>
                )}
            </Grid>
            <Grid container size={12}>
                <Grid size={12}>
                    <Box component={"h4"}>Serviço de instalação</Box>
                </Grid>

                {
                    turnkey ? (
                        <>
                            <Grid size={12}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Tipo de serviço:
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    TurnKey
                                </Typography>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor da instalação (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(projetoState?.valor_servico, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                            {(projetoState?.valor_margem_produtos || 0) > 0 && (
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor da margem de produtos (R$):
                                    </Typography>
                                    <Typography className={classes.pos} color="textSecondary">
                                        {Formater.toString(projetoState?.valor_margem_produtos, TypeRecords.CURRENCY)}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor líquido para revenda (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(valor_liquido_revenda, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </>
                    )
                }

            </Grid>
            <Grid container size={12}>
                <Grid size={12}>
                    <Box component={"h4"}>Valor total</Box>
                </Grid>
                { !turnkey && (
                        <>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor total dos produtos Intelbras com desconto (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString((projetoState?.valor || 0) - (projetoState?.valor_desconto || 0) - (pedidoEstate?.valor_desconto || 0), TypeRecords.CURRENCY) || "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography  className={classes.principal} variant="h5" component="h2">
                                    Valor do serviço com PIS/COFINS (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(projetoState?.valor_servico_pis_cofins, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </>
                    ) 
                }
                <Grid size={{ xs: 12, md: 2 }}>
                    <Typography  className={classes.principal} variant="h5" component="h2">
                        Valor total (R$):
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {Formater.toString(((projetoState?.valor || 0) - (projetoState?.valor_desconto || 0) + (projetoState?.valor_servico_pis_cofins || 0) - (pedidoEstate?.valor_desconto || 0)), TypeRecords.CURRENCY) || "-" }
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}>
                    <Typography  className={classes.principal} variant="h5" component="h2">
                        Valor total pago (R$):
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {Formater.toString((pedidoEstate?.valor_total_pago), TypeRecords.CURRENCY) || "-" }
                    </Typography>
                </Grid>
            </Grid>
        </>
        )   
    }
    const renderResumoOffgrid = (): ReactNode => {
        return (
            <>
                <Grid container size={12} className="modal-detalhes-tab-conteudo">
                    <Grid size={12}>
                        <Box component={"h4"}>Dados</Box>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Tensão:
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {parseTensaoOffgrid(projetoState?.solucao_sugerida?.tensao_saida as string) || '-'}
                        </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Potência do gerador (KWp):
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {projetoState?.potencia}
                        </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Tipo de pagamento:
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {projetoState?.valor_servico ? 'Gerador com instalação' : 'Apenas gerador sem instalação'}
                        </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Profissional de Vendas:
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {projetoState?.ev?.nome || '-'}
                        </Typography>
                    </Grid>
                </Grid>

                {/* Seção: Serviço de instalação */}
                <Grid container size={12} className="modal-detalhes-tab-conteudo">
                    <Grid size={12}>
                        <Box component={"h4"}>Serviço de instalação</Box>
                    </Grid>

                    {turnkey ? (
                        <Grid size={12}>
                            <Typography className={classes.principal} variant="h5" component="h2">
                                Tipo de serviço:
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                TurnKey
                            </Typography>
                        </Grid>
                    ) : (
                        <>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor da instalação (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(projetoState?.valor_servico, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                            {(projetoState?.valor_margem_produtos || 0) > 0 && (
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <Typography className={classes.principal} variant="h5" component="h2">
                                        Valor da margem de produtos (R$):
                                    </Typography>
                                    <Typography className={classes.pos} color="textSecondary">
                                        {Formater.toString(projetoState?.valor_margem_produtos, TypeRecords.CURRENCY)}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor líquido para revenda (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(valor_liquido_revenda, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </>
                    )}
                </Grid>

                {/* Seção: Valor total */}
                <Grid container size={12} className="modal-detalhes-tab-conteudo">
                    <Grid size={12}>
                        <Box component={"h4"}>Valor total</Box>
                    </Grid>
                    {!turnkey && (
                        <>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor total dos produtos Intelbras com desconto (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(
                                        (projetoState?.valor || 0) -
                                            (projetoState?.valor_desconto || 0) -
                                            (pedidoEstate?.valor_desconto || 0),
                                        TypeRecords.CURRENCY
                                    ) || "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography className={classes.principal} variant="h5" component="h2">
                                    Valor do serviço com PIS/COFINS (R$):
                                </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                    {Formater.toString(projetoState?.valor_servico_pis_cofins, TypeRecords.CURRENCY)}
                                </Typography>
                            </Grid>
                        </>
                    )}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Valor total (R$):
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {Formater.toString(
                                (projetoState?.valor || 0) -
                                    (projetoState?.valor_desconto || 0) +
                                    (projetoState?.valor_servico_pis_cofins || 0) -
                                    (pedidoEstate?.valor_desconto || 0),
                                TypeRecords.CURRENCY
                            ) || "-"}
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography className={classes.principal} variant="h5" component="h2">
                            Valor total pago (R$):
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            {Formater.toString(pedidoEstate?.valor_total_pago, TypeRecords.CURRENCY) || "-"}
                        </Typography>
                    </Grid>
                </Grid>
            </>
        );
    };
 
    useEffect(()=>{
        if (modalDetalhesModel.open){
            if (window.innerWidth > 1366 && window.innerHeight > 768){
                setControlDisplay(true);
            }
        }
    },[modalDetalhesModel.open]);

    useEffect(()=>{
        const loadingTime = 3000;
        setTimeout(() => {
            setIsLoading(false);
          }, loadingTime);
    },[])

    const observacaoPagamento = useMemo(() => {
        if (!pagamentoHistoricoLinhaEstate?.[0]) return "-"
        const notificaoRecente = pedidoNotificacoes?.[0]
        if (!notificaoRecente) return "-"
        const datasIguais = pagamentoHistoricoLinhaEstate[0].data_atualizacao_pagamento === notificaoRecente.data_envio
        if (datasIguais) return notificaoRecente?.observacao
        return "-"
    }, [pagamentoHistoricoLinhaEstate, pedidoNotificacoes])

    const statusPagamento = useMemo(()=>{
        const ultimoHistorico = pedidoEstate?.pagamentos_historico?.[0] || null
        if (pagamentoHistoricoLinhaEstate?.[0]?.data_atualizacao_pagamento === ultimoHistorico?.data_atualizacao_pagamento) {
            return formatarStatusPagamento(projetoState, pedidoEstate)
        }
        if (!ultimoHistorico && projetoState?.origem === "V1" && pagamentoHistoricoLinhaEstate?.length) {
            return parseSituacoesPagamento(projetoState?.status_projeto_pagamento || pagamentoHistoricoLinhaEstate?.[0]?.[pagamentoHistoricoLinhaEstate?.length - 1]?.situacao)
        }
        return "-"
    },[pagamentoHistoricoLinhaEstate, projetoState, pedidoEstate])

    const canceladoOuExpirado = useMemo(()=>{
        return projetoState?.status_projeto_pagamento === 'cancelado' || projetoState?.status_projeto_pagamento === 'expirado'
    },[projetoState])

    const ultimoHistoricoSelecionado = useMemo(()=>{
        const ultimoHistorico = pedidoEstate?.pagamentos_historico?.[0] || null
        const historicoSelecionado = pagamentoHistoricoLinhaEstate?.[0]
        return ultimoHistorico?.created_at === historicoSelecionado?.created_at
    },[pagamentoHistoricoLinhaEstate, pedidoEstate?.pagamentos_historico])

    const handleValorComissao = (projeto: any, pedido: any, comissao: any, tipo: string) => {
        if(tipo === "distribuidor"){
            return Formater.toString((pedido.valor_total_pago || 0) * ((comissao || 0)/100), TypeRecords.CURRENCY) || "-";
        }
        const valorComDesconto = projeto?.valor - projeto?.valor_desconto + projeto?.valor_servico_pis_cofins - (pedido?.valor_desconto ? pedido.valor_desconto : 0);
        return Formater.toString(((valorComDesconto || 0) * ((comissao || 0) / 100)), TypeRecords.CURRENCY) || "-";
    }

    const renderSituacaoPagamentoHistorico = useCallback((forma: string, dados: any, situacao: string, index = 0) => {
        if (forma === 'pix') {
            const dadosPix = dados[forma]?.sort((a: any, b: any) => {
                return Date.parse(b?.created_at || b?.data_expiracao) - Date.parse(a?.created_at || a?.data_expiracao)
            });
            const expirado = dadosPix?.[0]?.observacao === MENSAGEM_OBSERVACAO_EXPIRADO
            if (expirado) return parseSituacoesPagamento('expirado')
            
            const msgCancelado = dadosPix?.[0]?.observacao === MENSAGEM_OBSERVACAO_CANCELADO
            if (dadosPix?.[0]?.situacao === 'recusado' && msgCancelado) return parseSituacoesPagamento('cancelado')
            if (dados?.cartao_credito?.[0]?.situacao === 'recusado') return parseSituacoesPagamento('cancelado')
            if (dados?.carta_credito?.[0]?.situacao === 'recusado') return parseSituacoesPagamento('cancelado')
        }
        if (forma === 'boleto') {
            const dadosBoleto = dados[forma]?.sort((a: any, b: any) => {
                return Date.parse(b?.created_at || b?.data_vencimento) - Date.parse(a?.created_at || a?.data_vencimento)
            });
            if (dadosBoleto?.[0]?.situacao === 'recusado') return parseSituacoesPagamento('cancelado')
            if (dados?.carta_credito?.[0]?.situacao === 'recusado') return parseSituacoesPagamento('cancelado')
        }
        if (forma === 'cartao_credito') {
            const cartao = dados?.cartao_credito?.sort((a: any, b: any) => {
                return Date.parse(a?.created_at || a?.data_pagamento) - Date.parse(b?.created_at || b?.data_pagamento)
            });
            const dadosCartao = !FORMAS_PAGAMENTO_UNICO.includes(formaPagamentoId) ? cartao?.slice(-1) : dados?.cartao_credito;

            const somenteCartao = !dados['boleto']?.length && !dados['pix']?.length && !dados['financiamento']?.length && !dados['carta_credito']?.length;
            if (somenteCartao && dadosCartao?.length > 1 && dadosCartao?.some((ccItem: any) => ccItem.situacao === 'cancelado')) {
                return parseSituacoesPagamento('recusado')
            }

            if (dadosCartao?.length && canceladoOuExpirado && ultimoHistoricoSelecionado) {
                const possuiFinanciamento = !!(dados['carta_credito']?.length || dados['financiamento']?.length);
                if (possuiFinanciamento && (dados['carta_credito'][0]?.situacao === 'cancelado' || dados['financiamento'][0]?.situacao === 'cancelado')) {
                    return parseSituacoesPagamento('cancelado')
                }
                return parseSituacoesPagamento(dadosCartao[0]?.situacao)
            }
            if (dadosCartao?.length && !canceladoOuExpirado && ultimoHistoricoSelecionado) return parseSituacoesPagamento(dadosCartao[0]?.situacao)
        }
        if (forma === 'carta_credito') {
            const statusBloqueado = ['cancelado','expirado','recusado'];
            const statusProjetoPagamento = projetoState?.status_projeto_pagamento || '';
            const statusProjetoPagamentoBloqueado = statusBloqueado?.includes(statusProjetoPagamento)
            // Se for pagamento combinado com financiamento externo, e a segunda forma for recusada/recusado, deve exibir cancelado
            if (statusProjetoPagamentoBloqueado && !statusBloqueado?.includes(situacao) && !FORMAS_PAGAMENTO_UNICO.includes(formaPagamentoId)) return parseSituacoesPagamento('cancelado')
        }
        if(forma === 'varejo') {
            const dadosVarejo = dados[forma]?.sort((a: any, b: any) => {
                return Date.parse(b?.created_at || b?.data_pagamento) - Date.parse(a?.created_at || a?.data_pagamento)
            });
            if (dadosVarejo?.[0]?.situacao === 'recusado') return parseSituacoesPagamento('cancelado', forma)
            if (dadosVarejo?.[0]?.situacao === 'pendente') return parseSituacoesPagamento('emissao_nota_varejo', forma)
            return parseSituacoesPagamento(dadosVarejo?.[0]?.situacao);
        }
        if (dados && !canceladoOuExpirado) return parseSituacaoHistorico(forma, dados, index)
        return parseSituacoesPagamento(situacao) || '-'
    }, [canceladoOuExpirado, ultimoHistoricoSelecionado, formaPagamentoId, projetoState?.status_projeto_pagamento])

    const visitaTecnicaV1 = useMemo(()=>{
        return (projetoState?.origem === 'V1' && !!projetoState?.dados_visita_tecnica)
    },[projetoState])

    const previsaoTermosV1 = useMemo(()=>{
        return (projetoState?.origem === 'V1' && !!projetoState?.dados_finalizar)
    },[projetoState])

    const inversorTensao = useMemo(()=> {
        const tensao = hibrido 
            ? projetoState?.solucao_sugerida?.tensao_saida 
            : projetoState?.solucao_sugerida?.inversor_tensao;
        return parseTensao((tensao as any), hibrido) || '-'
    },[projetoState, hibrido]);

    const tipoConexao = useMemo(()=> {
        const fase = hibrido 
            ? projetoState?.solucao_sugerida?.tipo_ligacao 
            : projetoState?.solucao_sugerida?.inversor_tipo_conexao;
        return parseFase((fase as any)) || '-'
    },[projetoState, hibrido]);

    const tipoInversor = useMemo(()=> {
        if (hibrido) return 'Inversor Híbrido';
        if (!projetoState?.solucao_sugerida?.tipo_inversor) return '-'
        return inversoresMap[projetoState?.solucao_sugerida?.tipo_inversor]?.text || '-'
    },[projetoState, hibrido])

    const tipoBateria = useMemo(()=> {
        const componentes = projetoState?.componentes || [];
        if (!componentes.length) return "Sem bateria";
        
        const baterias = componentes.filter(i => LISTA_BATERIAS?.includes(i?.componente?.categoria_componentes_id))
        if (!baterias.length) return "Sem bateria";

        const tiposBateria: {[key: string]: string} = {
            "1": "Bateria de Chumbo",
            "2": "Bateria de Lítio",
        }

        const tiposBaterias = baterias.map(b => (b.componente.atributos || []).find((item: any) => item.atributo === 'BATEIRA_TIPO')?.valor || 0);
        const tiposUnicosBaterias = Array.from(new Set(tiposBaterias));

        if (tiposUnicosBaterias.length === 0) return "Sem bateria";
        if (tiposUnicosBaterias.length > 1) return "Bateria de Lítio";
        if (tiposUnicosBaterias.length === 1) return tiposBateria[tiposUnicosBaterias[0]] || "Sem bateria";

        return "Sem bateria";

    },[projetoState])

    const itensPedido = useMemo(()=> {
        if (projetoState?.origem !== ORIGEM_HISTORICO_V1) return [];
        const _itensNf = pedidoShowHistoricosErp?.notas_fiscais?.[0]?.itens || [];
        const _componentes = pedidoShowHistoricosErp?.itens?.filter((i:any) => i.quantidade > 0) || [];
        return pedidoShowHistoricosErp?.dados_migracao?.Itens?.filter((i:any) => !_componentes?.find((ii:any) => Number(i.Produto) === ii.componente_id) && !_itensNf?.find((ii:any) => Number(i.Produto) === Number(ii.codigo))) || [];
    },[projetoState?.origem, pedidoShowHistoricosErp])

    const handleClick = useCallback(async (event) => {
        event.preventDefault();
        
        if (projetoState?.id) {
            adminStore.buscarProjeto(projetoState?.id, true).then((resp) => {
                if (resp?.length) window.open(hashCodVenda, "_blank", "noopener,noreferrer");
            });
        } else {
            window.open(hashCodVenda, "_blank", "noopener,noreferrer");
        }
    }, [projetoState, hashCodVenda])

    const renderTextoVisitaTecnica = useCallback(()=>{
        if (!projetoState?.visita_tecnica_texto) return null;
        const checklist = projetoState.visita_tecnica_texto?.checklist
        const listaDeItems = checklist && checklist.length > 0 && typeof checklist[0] === 'string'

        if (listaDeItems) {
            return (
                <Box component='p'>
                    {BASE_TEXT}
                    <Box component='ul'>
                        {projetoState?.visita_tecnica_texto?.checklist?.map((row: any) => (
                            <Box component='li'>
                                {row}
                            </Box>
                        ))}
                    </Box>
                </Box>
            )
        }
        return (<Box component='p'>
            {BASE_TEXT}
            <Box component='ul'>
                {projetoState?.visita_tecnica_texto?.checklist?.map((row: any) => (
                    <>
                    <Box component='li'>
                        {row.texto}
                    </Box>                    
                    
                    {row.itens?.length && (
                        <Box component='ul'>
                            {row.itens.map((item: any) => (
                                <Box component='li'>
                                    {item.texto}
                                </Box>
                            ))}
                        </Box>
                    )}
                    </>
                ))}
            </Box>
        </Box>)

    }, [projetoState?.visita_tecnica_texto]);

    const listTabMobile = useMemo(() => {
        return DEFAULT_TABLIST?.filter(tab => {
            if (tab.allowed) return true;
            switch (tab.text) {
                case 'DISTRIBUIDOR':
                    return (!!userInfo?.isDistribuidor || !!userInfo?.isIntelbras);
                case 'REVENDA':
                    return ((!!userInfo?.isRevenda || !!userInfo?.isIntelbras || !!userInfo?.isDistribuidor) && !!projetoState?.revenda);
                case 'CONFIRMAÇÃO VISITA TÉCNICA':
                    return (projetoState?.visita_tecnica_texto || visitaTecnicaV1);
                case 'TERMOS DO PROJETO':
                    return ((projetoState?.dados_termo && projetoState?.tipo !== 'vertical'));
                case 'FINALIZAÇÃO DE PROJETO':
                    return (projetoState?.dados_finalizar_renovigi?.observacao);
                default:
                    return false;
        
            }
        })
    }, [
        userInfo?.isDistribuidor,
        userInfo?.isRevenda, 
        userInfo?.isIntelbras, 
        projetoState?.revenda, 
        projetoState?.visita_tecnica_texto, 
        projetoState?.dados_termo, 
        projetoState?.tipo, 
        projetoState?.dados_finalizar_renovigi?.observacao, 
        visitaTecnicaV1
    ]);

    const listHitoricoPedido = useMemo(() => {
        return pedidoHistoricosErp?.map((row: any) => ({ text: moment(row?.data_evento).format("DD/MM/YYYY - HH:mm:ss"), value: row?.data_evento })) || [];
    }, [pedidoHistoricosErp]);

    const listHitoricoPagamento = useMemo(() => {
        return pagamentoHistoricoEstate?.map((row: any) => ({ text: moment(row?.data_atualizacao_pagamento).format("DD/MM/YYYY - HH:mm:ss"), value: row?.data_atualizacao_pagamento })) || [];
    }, [pagamentoHistoricoEstate]);

    const listHitoricoNf = useMemo(() => {
        if (nfHistoricoEstate?.length) {
            return nfHistoricoEstate?.map((row: any) => ({ text: formatData(row?.data_criacao || row?.created_at), value: (row?.data_criacao || row?.created_at) })) || [];
        } else if (!nfHistoricoEstate?.length && nfShowEstate) {
            return [{text: formatData(nfShowEstate?.data_criacao || nfShowEstate?.created_at), value: (nfShowEstate?.data_criacao || nfShowEstate?.created_at) }];
        } else {
            return [];
        }
    }, [nfHistoricoEstate, nfShowEstate]);

    useEffect(()=> {
        if (!currentHistoricoPedido && listHitoricoPedido?.length) {
            setCurrentHistoricoPedido(listHitoricoPedido?.[0]?.value);
        }
    }, [listHitoricoPedido, currentHistoricoPedido]);

    useEffect(()=> {
        if (!currentHistoricoPagamento && listHitoricoPagamento?.length) {
            setCurrentHistoricoPagamento(listHitoricoPagamento?.[0]?.value);
        }
    }, [listHitoricoPagamento, currentHistoricoPagamento]);

    useEffect(()=> {
        if (!currentHistoricoNf && listHitoricoNf?.length && !loadingNf) {
            setCurrentHistoricoNf(listHitoricoNf?.[0]?.value);
        }
    }, [listHitoricoNf, currentHistoricoNf, loadingNf]);

    return (
        <>
            <div>
            {(projetoState && !openModalVisualizarProposta) &&
                <Dialog
                    open={modalDetalhesModel.open}
                    onClose={handleClose}
                    maxWidth='md'
                    style={{height: controlDisplay ? "85%" : "100%"}}
                    className="modal-detalhes"
                >
                    <DialogTitle style={isMobile?  { padding: 0 } : {}}>
                        <Grid container size={12}>
                            <Grid size={12}>
                                <Box style={{fontSize: "20px"}} component={"h2"} className="box-detalhes">Detalhes</Box>
                                <Box style={{fontSize: "14px"}} component={"p"} className="box-codigo-venda">
                                    {projetoState.codigo_venda}
                                    <CopyToClipboard text={projetoState.codigo_venda || ""}
                                        onCopy={() => {
                                            setCopied(true)
                                            setTimeout(()=>{setCopied(false)},900)
                                            }}>
                                        <FlatButton
                                            size="small"
                                            startIcon={<FontAwesomeIcon icon={faCopy} color="#5F5F5F"/>}
                                        >
                                        </FlatButton>
                                    </CopyToClipboard>
                                    {copied ? <span style={
                                        {
                                            color: "#f7fcf9",
                                            background:"#00af39",
                                            border: "1px solid #00af39",
                                            borderRadius: "4px",
                                            minWidth: "120px",
                                            height: "40px",
                                            boxShadow: "0 2px 10px gray"
                                        }}>Código copiado!</span> : null}
                                </Box>
                                {
                                    isMobile ? (
                                        <FormControl fullWidth className="form-select-aba">
                                            <Typography className={classes.label} color="textSecondary">
                                                Selecione a aba que deseja visualizar:
                                            </Typography>
                                            <InputSelectSimple
                                                fullWidth
                                                label={undefined}
                                                defaultValue={tabMobile}
                                                value={listTabMobile?.find(i => i.value === tabMobile)?.value}
                                                list={listTabMobile}
                                                onChange={(value) => setTabMobile(value)}
                                            />
                                        </FormControl>
                                    ) : (
                                        <AppBar color="inherit" position="static" >
                                            <Tabs 
                                                value={valueState} 
                                                onChange={(_e, value) => handleChange(value, 0)}
                                                aria-label="Tabs de detalhes do pedido"
                                                variant="standard"
                                                scrollButtons={false}
                                                sx={{
                                                    '& .MuiTabs-indicator': {
                                                        backgroundColor: '#50788A',
                                                    },
                                                    '& .MuiTab-root': {
                                                        color: 'inherit',
                                                        opacity: 0.7,
                                                        '&.Mui-selected': {
                                                            opacity: 1,
                                                        },
                                                    }
                                                }}
                                            >
                                                {!avulso && (<Tab label="RESUMO" {...a11yProps(0)} />)}
                                                <Tab label="PRODUTOS" {...a11yProps(1)} />
                                                {(!!userInfo?.isDistribuidor || !!userInfo?.isIntelbras) && 
                                                    <Tab label={'DISTRIBUIDOR'} {...a11yProps(2)} />
                                                }
                                                {((!!userInfo?.isRevenda || !!userInfo?.isIntelbras || !!userInfo?.isDistribuidor) && !!projetoState?.revenda) &&
                                                    <Tab label='REVENDA' {...a11yProps(3)} />
                                                }
                                                <Tab label="CLIENTE" {...a11yProps(4)} />
                                                {(!projetoState?.revenda || avulso) && <Tab label="PAGAMENTO" {...a11yProps(10)} />}
                                                {!projetoState?.revenda && avulso && <Tab label="NOTA FISCAL" {...a11yProps(11)} />}
                                            </Tabs>
                                            <Tabs 
                                                value={valueState - 5}
                                                onChange={(_e, value) => handleChange(value, 5)}
                                                aria-label="Tabs de detalhes do pedido"
                                                variant="standard"
                                                scrollButtons={false}
                                                sx={{
                                                    '& .MuiTabs-indicator': {
                                                        backgroundColor: '#50788A',
                                                    },
                                                    '& .MuiTab-root': {
                                                        color: 'inherit',
                                                        opacity: 0.7,
                                                        '&.Mui-selected': {
                                                            opacity: 1,
                                                        },
                                                    }
                                                }}
                                            >
                                                {(projetoState?.revenda && !avulso) && <Tab label="PAGAMENTO" {...a11yProps(5)} />}
                                                {(!avulso || (avulso && !!projetoState?.revenda)) && <Tab label="NOTA FISCAL" {...a11yProps(6)} />}
                                                <Tab label="PEDIDO" {...a11yProps(7)} />
                                                <Tab label="ENTREGAS" {...a11yProps(8)} />
                                                <Tab label="PREVISÃO DE FATURAMENTO" {...a11yProps(9)} />
                                                { ((!projetoState.revenda && avulso && projetoState?.dados_termo && projetoState.tipo !== 'vertical')) &&
                                                    <Tab label="TERMOS DO PROJETO" {...a11yProps(16)} />
                                                }
                                            </Tabs>

                                            { (!!projetoState?.dados_finalizar_renovigi?.observacao || (projetoState?.visita_tecnica_texto || visitaTecnicaV1) || ((projetoState?.dados_termo && projetoState.tipo !== 'vertical'))) &&
                                            <Tabs 
                                                value={valueState - 10}
                                                onChange={(_e, value) => handleChange(value, 10)}
                                                aria-label="Tabs de detalhes do pedido"
                                                variant="standard"
                                                scrollButtons={false}
                                                sx={{
                                                    '& .MuiTabs-indicator': {
                                                        backgroundColor: '#50788A',
                                                    },
                                                    '& .MuiTab-root': {
                                                        color: 'inherit',
                                                        opacity: 0.7,
                                                        '&.Mui-selected': {
                                                            opacity: 1,
                                                        },
                                                    }
                                                }}
                                            >
                                                { (projetoState?.visita_tecnica_texto || visitaTecnicaV1) &&
                                                    <Tab label="CONFIRMAÇÃO VISITA TÉCNICA" {...a11yProps(10)} />
                                                }
                                                { (((projetoState?.dados_termo && projetoState.tipo !== 'vertical') && !avulso) || (avulso && !!projetoState.revenda)) &&
                                                    <Tab label="TERMOS DO PROJETO" {...a11yProps(11)} />
                                                }
                                                {projetoState?.dados_finalizar_renovigi?.observacao && (
                                                    <Tab label="FINALIZAÇÃO DE PROJETO" {...a11yProps(12)} />
                                                )}
                                            </Tabs>
                                            }
                                        </AppBar>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>                    
                        <Box style={{height: isMobile ? "80vh" : "400px"}} id="modal-detalhes-main-container">
                            <Grid container size={12} className="modal-detalhes-conteudo">
                                {!avulso && (<TabPanel value={isMobile ? tabMobile : valueState} index={0}>
                                    <Grid ref={contentRef} container size={12} className="modal-detalhes-tab">
                                        {/*Aba Resumo - Segmentada conforme segmento do projeto - SOL-3346*/}
                                        {projetoState?.segmento?.includes("offgrid") ? renderResumoOffgrid() : renderResumo()}
                                    </Grid>
                                </TabPanel>)}
                                <TabPanel value={isMobile ? tabMobile : valueState} index={1}>
                                    {isMobile ? (
                                            <>
                                                {listaComponentes?.map(renderProductMobile)}
                                                <Grid container size={12} className="box-valor-total">
                                                    { getRodapeTabelaProdutos(projetoState?.valor_total_produtos || 0) }
                                                </Grid>
                                            </>
                                        ) : (
                                            <TableContainer ref={contentRef} component={Paper}>
                                                <Table className={classes.table} size="small" aria-label="a dense table">
                                                    {isLoading ? <>
                                                            <LoadingSpinner/>
                                                        </>:(<>
                                                    <TableHead>
                                                    <TableRow>
                                                        { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE) &&
                                                            <TableCell align="left">Código</TableCell>
                                                        }
                                                        <TableCell>Nome</TableCell>
                                                        <TableCell align="right" style={{maxWidth:"90px", width:"90px"}}>Quantidade</TableCell>
                                                        { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_FATOR) &&
                                                            <TableCell style={{paddingRight:"5px"}} align="left">
                                                                    <a style={{paddingRight:"3px"}}>Fator</a>
                                                                    <Tooltip title="Os valores podem variar conforme o número de casas decimais consideradas.">                                                            
                                                                        <InfoOutlined
                                                                            htmlColor={theme.palette.grey[600]}
                                                                            fontSize={"inherit"}
                                                                        />
                                                                    </Tooltip>                          
                                                            </TableCell>    
                                                        }
                                                        { getPermissao(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES) &&
                                                            <>
                                                            <TableCell align="left" style={{minWidth:"130px", width:"130px"}}>Valor Original</TableCell>
                                                            <TableCell style={{paddingRight:"5px"}} align="left">
                                                                <a style={{paddingRight:"3px"}}>Valor Final</a>
                                                                <Tooltip title="O valor final é calculado multiplicando o valor original pelo fator.">                                                            
                                                                    <InfoOutlined
                                                                        htmlColor={theme.palette.grey[600]}
                                                                        fontSize={"inherit"}
                                                                    />
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell align="left">Total Final</TableCell>
                                                            </>
                                                        }
                                                        <TableCell align="left">Dados Técnicos</TableCell>
                                                            
                                                    </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {listaComponentes?.map((row) => renderProductRow(row, avulso))}
                                                        <TableRow className="footer-table">
                                                            { getRodapeTabelaProdutos(projetoState?.valor_total_produtos || 0) }
                                                        </TableRow>
                                                    </TableBody>
                                                    </>)}
                                                </Table>
                                            </TableContainer>
                                        )
                                    }
                                </TabPanel>
                                {(!!userInfo?.isDistribuidor || !!userInfo?.isIntelbras)  && 
                                    <TabPanel value={isMobile ? tabMobile : valueState} index={2}>
                                        <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        CPF/CNPJ:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {Formater.toString(projetoState?.distribuidor?.cnpj_cpf, TypeRecords.CPF_CNPJ)}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Nome/Razão social:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.nome || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Telefone:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.telefone ? maskPhone(projetoState?.distribuidor?.telefone) : '-'}
                                                        
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        E-mail:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.email || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Percentual do Distribuidor (%):
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {Number(projetoState?.percentual_comissao_distribuidor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Valor do Distribuidor:
                                                    </Typography>
                                                    {!!pedidoEstate?.pedido_erp ? (
                                                        <Typography className={classes.pos} color="textSecondary">
                                                            {handleValorComissao(projetoState, pedidoEstate, projetoState?.percentual_comissao_distribuidor_sap, "distribuidor")}
                                                        </Typography>
                                                    ) : (
                                                        <Typography className={classes.pos} color="textSecondary">
                                                            Cálculo de verba de suporte a projetos em processamento
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Estado:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.cidade?.estado_id || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Cidade:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.cidade?.nome || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        CEP:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.cep ? Formater.toCEP(projetoState.distribuidor.cep) : '-' }
                                                    </Typography>
                                                </Grid>
                                                
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Logradouro:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.logradouro || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Número:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.numero || '-' }
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Bairro:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.bairro || '-'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                        Complemento:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.distribuidor?.complemento || '-'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                }
                                {(!!userInfo?.isRevenda || !!userInfo?.isIntelbras || !!userInfo?.isDistribuidor)  && 
                                    <TabPanel value={isMobile ? tabMobile : valueState} index={3}>
                                        <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        CPF/CNPJ:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {Formater.toString(projetoState?.revenda?.cnpj_cpf, TypeRecords.CPF_CNPJ)}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Nome/Razão social:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.nome || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Telefone:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.telefone ? maskPhone(projetoState?.revenda?.telefone) : '-'}
                                                        
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        E-mail:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.email || '-'}
                                                    </Typography>
                                                </Grid>
                                                {projetoState.servico === 'intelbras' && !!pedidoEstate?.pedido_erp && (
                                                    <>
                                                        <Grid size={{ xs: 12, md: 4 }}>
                                                            <Typography  className={classes.principal} variant="h5" component="h2">
                                                                Percentual de Comissão (%):
                                                            </Typography>
                                                            <Typography className={classes.pos} color="textSecondary">
                                                                {Number(projetoState?.percentual_comissao_revenda || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, md: 4 }}>
                                                            <Typography  className={classes.principal} variant="h5" component="h2">
                                                                Valor comissão:
                                                            </Typography>
                                                            <Typography className={classes.pos} color="textSecondary">
                                                                {handleValorComissao(projetoState, pedidoEstate, projetoState?.percentual_comissao_revenda_sap, "revenda")}
                                                            </Typography>
                                                        </Grid>       
                                                    </>
                                                )}                                     
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Estado:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.cidade?.estado_id || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Cidade:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.cidade?.nome || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        CEP:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.cep ? Formater.toCEP(projetoState.revenda.cep) : '-'}
                                                    </Typography>
                                                </Grid>
                                                
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Logradouro:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.logradouro || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Número:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.numero || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography  className={classes.principal} variant="h5" component="h2">
                                                        Bairro:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.bairro || '-'}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Complemento:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {projetoState?.revenda?.complemento || '-'}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Serviço pago:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        -
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 4 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Valor serviço:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {Formater.toString((valor_liquido_revenda || 0), TypeRecords.CURRENCY)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={12}>
                                                {Number(projetoState.valor_servico) > 0 && (
                                                    <>
                                                    <Grid size={{ xs: 12, md: 4 }}>
                                                        <Typography className={classes.principal} variant="h5" component="h2">
                                                            Situação da documentação:
                                                        </Typography>
                                                        <Typography className={classes.pos} color="textSecondary">
                                                            {situacaoDocumentacaoServico}
                                                        </Typography>
                                                    </Grid>
                                                    </>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                }
                                <TabPanel value={isMobile ? tabMobile : valueState} index={4}>
                                    <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                        <Grid container size={12}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Cliente da proposta final</Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Nome:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {projetoState?.tipo_faturamento === 'integrador'  
                                                        ? (projetoState?.revenda?.nome || projetoState?.distribuidor?.nome || '-')
                                                        : (projetoState?.cliente_proposta || '-')}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    CPF:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {projetoState?.tipo_faturamento === 'integrador'  
                                                        ? (
                                                            Formater.toString(projetoState?.revenda?.cnpj_cpf, TypeRecords.CPF_CNPJ) || 
                                                            Formater.toString(projetoState?.distribuidor?.cnpj_cpf, TypeRecords.CPF_CNPJ)
                                                        ) : (Formater.toString(projetoState?.cpf_cnpj_proposta, TypeRecords.CPF_CNPJ) || '-')}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    E-mail:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {projetoState?.tipo_faturamento === 'integrador'  
                                                        ? (projetoState?.revenda?.email || projetoState?.distribuidor?.email || '-')
                                                        : (projetoState?.email_proposta || '-')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={12}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Endereço:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {projetoState?.tipo_faturamento === 'integrador'  
                                                        ? (
                                                            (projetoState?.revenda && getEnderecoRevenda()) || 
                                                            (projetoState?.distribuidor && getEnderecoDistribuidor())
                                                        ) : (projetoState?.endereco ? getEnderecoCliente() : '-')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Cliente pagador (destinatário da NF)</Box>
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    CPF/CNPJ:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {Formater.toString(pedidoEstate?.cliente?.documento, TypeRecords.CPF_CNPJ)}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Nome/Razão Social:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoEstate?.cliente?.nome || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    E-mail:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoEstate?.cliente?.email || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Telefone:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                {pedidoEstate?.cliente?.telefone ? maskPhone(pedidoEstate?.cliente?.telefone) : '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Cidade:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    { pedido_endereco?.cidade ? pedido_endereco?.cidade?.nome : '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Estado:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    { pedido_endereco?.cidade ? pedido_endereco?.cidade?.estado_id : '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Logradouro:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.logradouro || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Número:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.numero || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Bairro:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.bairro || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container size={12}>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    CEP:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {Formater.toCEP(pedido_endereco?.cep) || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 4 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Complemento:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.complemento || '-'}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={isMobile ? tabMobile : valueState} index={10}>
                                    <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                        {isMobile && (
                                            <Grid container size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"} style={{ marginBottom: 5 }}>Histórico</Box>
                                                    {!!listHitoricoPagamento?.length && (
                                                        <Box style={{ marginBottom: 10 }}>
                                                            <Typography className={classes.label} color="textSecondary">
                                                                Selecione abaixo um registro para visualizar todo o histórico:
                                                            </Typography>
                                                            <InputSelectSimple
                                                                fullWidth
                                                                label={undefined}
                                                                defaultValue={currentHistoricoPagamento}
                                                                value={listHitoricoPagamento?.find((i:any) => i.value === currentHistoricoPagamento)?.value || ""}
                                                                list={listHitoricoPagamento}
                                                                onChange={(value) => {
                                                                    setCurrentHistoricoPagamento(value);
                                                                    setPagamentoHistoricoLinha(pagamentoHistoricoEstate.filter((hp: any) => hp?.data_atualizacao_pagamento === value))
                                                                }}
                                                            />
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid container size={{ xs: 12, md: 8 }}>
                                            <Grid size={{ xs: 12, md: 7 }}>
                                                <Grid size={12}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Forma de pagamento:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {(pagamentoHistoricoLinhaEstate && pagamentoHistoricoLinhaEstate.length && !pagamentoHistoricoLinhaEstate[0]?.dados_integracao?.migracao) ?(<>
                                                            {parseFormaPagamentoHistorico(pagamentoHistoricoLinhaEstate[0].dados_integracao, "", formaPagamentoId)}
                                                            </>
                                                        )
                                                        : (projetoState?.origem === "V1" && pagamentoHistoricoLinhaEstate?.length && parseNomePagamentoV1(pagamentoHistoricoLinhaEstate[0])) || "-"}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Status de pagamento:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {statusPagamento}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Link de acesso ao pagamento:
                                                    </Typography>
                                                    {hashCodVenda ? (<Typography className={classes.pos} color="textSecondary">    
                                                        <a href="#" role="button" onClick={handleClick} rel="noreferrer">Clique aqui e acesse o portal de pagamentos</a>
                                                    </Typography>) : 
                                                    (((pedidoEstate?.etapa_pedido === "envio_pagamento" && !hashCodVenda) || (projetoState?.tipo === 'kit' && !pedidoEstate)) ? 
                                                    (<>                                                        
                                                        <EnviarPagamentoButton
                                                            codigoVenda={projetoState?.codigo_venda}
                                                            notaTriangular={projetoState?.tipo_faturamento === "integrador_cliente"}
                                                            tipoProposta={projetoState?.tipo_proposta_envio}
                                                            idProjeto={projetoState?.id}
                                                            onFinish={(url: string)=>{
                                                                setRefreshState(true);
                                                                setProjetoState({
                                                                    ...projetoState,
                                                                    url_pagamento: url
                                                                });
                                                            }}
                                                        />
                                                    </>) : (<Typography
                                                            style={{fontSize: "inherit", fontFamily: "inherit"}}
                                                        >
                                                            Ainda não enviado para pagamento!
                                                        </Typography>)
                                                    )}
                                                </Grid>
                                                {hashCodVenda && 
                                                        (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_REENVIAR_EMAIL_PAGAMENTO, permissoes) || PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_COPIAR_LINK_PAGAMENTO, permissoes))? <>
                                                        <Grid size={12} style={{marginTop: "-8px", display: "flex", flexDirection: isMobile ? "column" : "row"}} className="acoes-aba-pagamentos">
                                                            {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_REENVIAR_EMAIL_PAGAMENTO, permissoes) ? <>
                                                                <Tooltip title={!is15MinutesBeforeNow() ? "Aguarde 15 minutos antes de enviar novamente" : ""}>
                                                                    <div>
                                                                        <VerticalButton
                                                                            variant="outlined"
                                                                            color="secondary"
                                                                            style={is15MinutesBeforeNow() ? { color: "rgba(0, 0, 0, 0.87)", marginRight: "5px", padding: "1px 5px 1px 5px" } : { marginRight: "5px", padding: "1px 5px 1px 5px", backgroundColor: "rgba(0, 0, 0, 0.12)", color: "rgba(0, 0, 0, 0.26)", borderColor: "rgba(0, 0, 0, 0.12)"}}
                                                                            disabled={!is15MinutesBeforeNow()}
                                                                            startIcon={<Email />}
                                                                            fullWidth={isMobile}
                                                                            className="btn-reenviar-link-pagamento"
                                                                            onClick={() => {
                                                                                handleReenviarEmailPagamento();
                                                                            }}
                                                                        >
                                                                            Reenviar e-mail
                                                                        </VerticalButton>
                                                                    </div>
                                                                </Tooltip>
                                                            </> : <></>}
                                                            {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_COPIAR_LINK_PAGAMENTO, permissoes) ? <Box className="box-copiar-link-pagamento">
                                                                <CopyToClipboard text={hashCodVenda || ""}
                                                                    disabled={!hashCodVenda}
                                                                    onCopy={() => {
                                                                        const _copiedPagamento = {exibir: true, erro: false, texto: "Link copiado!"};
                                                                        setCopiedPagamento(_copiedPagamento);
                                                                        setTimeout(()=>{setCopiedPagamento({exibir: false, erro: false, texto: ''})},900)
                                                                    }}
                                                                > 
                                                                    <VerticalButton
                                                                        variant="outlined"
                                                                        color="secondary"
                                                                        disabled={!hashCodVenda}
                                                                        style={{ color: "rgba(0, 0, 0, 0.87)", padding: "1px 5px 1px 5px", marginRight: "5px" }}
                                                                        startIcon={<Link />}
                                                                        fullWidth={isMobile}
                                                                        className="btn-copiar-link-pagamento"
                                                                    >
                                                                        Copiar link
                                                                    </VerticalButton>
                                                                </CopyToClipboard>
                                                            </Box> : <></>}
                                                            <div style={{position: "relative"}}>
                                                                {copiedPagamento?.exibir 
                                                                    ? <span style={
                                                                        {
                                                                            position: "absolute",
                                                                            color: "#f7fcf9",
                                                                            background: `${!copiedPagamento?.erro ? '#00af39': '#b91222'}`,
                                                                            border: `1px solid ${!copiedPagamento?.erro ? '#00af39': '#b91222'}`,
                                                                            borderRadius: "4px",
                                                                            minWidth: `${!copiedPagamento?.email ? "90px" : "190px"}`,
                                                                            height: "auto",
                                                                            boxShadow: "0 2px 10px gray",
                                                                            fontSize: "14px",
                                                                            top: "25%"
                                                                        }}>
                                                                            {copiedPagamento?.texto}</span> 
                                                                    : null}
                                                            </div>
                                                    </Grid>
                                                </> : <></>}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 5 }}>
                                                <Grid size={12}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Observações:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {observacaoPagamento}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            {pagamentoHistoricoLinhaEstate?.map((row: any) => (
                                                <>
                                                    {parseDadosIntegracaoHistorico(row?.dados_integracao, row)}
                                                </>
                                            ))}
                                        </Grid>
                                        {!isMobile && (
                                            <Grid container size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Histórico</Box>
                                                    <Box component={"p"}>Selecione abaixo um registro para visualizar todo o histórico</Box>
                                                    <TableContainer component={Paper}>
                                                        <Table size="small" aria-label="a dense table" className={classes.tableHistorico}>
                                                            <TableBody>
                                                                {pagamentoHistoricoEstate?.map((row: any) => (
                                                                    <TableRow key={row?.id} style={{background: `${pagamentoHistoricoLinhaEstate?.[0]?.data_atualizacao_pagamento === row?.data_atualizacao_pagamento ? 'rgba(0, 0, 0, 0.54)' : ''}`}} onClick={() => {
                                                                            setPagamentoHistoricoLinha(pagamentoHistoricoEstate.filter((hp: any) => hp?.data_atualizacao_pagamento === row?.data_atualizacao_pagamento))
                                                                        }}>
                                                                        <TableCell component="th" scope="row">
                                                                            {moment(row?.data_atualizacao_pagamento).format("DD/MM/YYYY - HH:mm:ss")}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={isMobile ? tabMobile : valueState} index={11}>
                                    <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                        {isMobile && (
                                            <Grid container size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"} style={{ marginBottom: 5 }}>Histórico</Box>
                                                    {!!listHitoricoNf?.length && (
                                                        <Box style={{ marginBottom: 10 }}>
                                                            <Typography className={classes.label} color="textSecondary">
                                                                Selecione abaixo um registro para visualizar todo o histórico:
                                                            </Typography>
                                                            <InputSelectSimple
                                                                fullWidth
                                                                label={undefined}
                                                                defaultValue={currentHistoricoNf}
                                                                value={listHitoricoNf?.find((i:any) => i.value === currentHistoricoNf)?.value || ""}
                                                                list={listHitoricoNf}
                                                                onChange={(value) => {
                                                                    setCurrentHistoricoNf(value);
                                                                    setNFHistoricoLinha(nfHistoricoEstate?.filter((row: any) => (row?.data_criacao || row?.created_at) === value))
                                                                }}
                                                            />
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid container size={{ xs: 12, md: 8 }}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Dados da Nota Fiscal</Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Número da nota:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    { danfeNF ? (
                                                        <Tooltip title="Baixar Danfe">
                                                            <button
                                                                className={classes.link}
                                                                onClick={() => UrlUtil.goto(resolveProtocolUrl(`//${uploadInfo?.data?.url}${danfeNF.url}`), true)}
                                                            >
                                                                {nfShowEstate?.numero || '-'}
                                                                <LaunchOutlined className={classes.icon}/>
                                                            </button>
                                                        </Tooltip> ) : ( `${nfShowEstate?.numero || '-'}` 
                                                    )}
                                                    { xmlNF ? (
                                                        <Box>
                                                            <Tooltip title="Baixar XML">
                                                                <button
                                                                    className={classes.link}
                                                                    onClick={() => UrlUtil.goto(resolveProtocolUrl(`//${uploadInfo?.data?.url}${xmlNF.url}`), true)}
                                                                >
                                                                    {nfShowEstate?.numero || '-'}
                                                                    <LaunchOutlined className={classes.icon}/>
                                                                </button>
                                                            </Tooltip>
                                                        </Box> ) : ("")
                                                    }
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Valor total (R$):
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {Formater.toString(nfShowEstate?.valor, TypeRecords.CURRENCY)}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Peso bruto:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {`${Formater.toString(nfShowEstate?.peso_bruto, TypeRecords.CURRENCY).replace("R$", "")} kg` || '-'}
                                                </Typography>
                                            </Grid>
                                            {!isMobile && (
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Nota de devolução:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {(projetoState?.origem === 'V1' && nfShowEstate?.dados_migracao?.NotaDevolucao) ? "1" : "-"}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Estado:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    { pedido_endereco?.cidade ? pedido_endereco?.cidade?.estado_id : '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Cidade:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    { pedido_endereco?.cidade ? pedido_endereco?.cidade?.nome : '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Logradouro:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.logradouro || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Número:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.numero || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Bairro:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.bairro || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    CEP:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {Formater.toCEP(pedido_endereco?.cep) || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Complemento:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedido_endereco?.complemento || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Observação:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {(projetoState?.origem === 'V1' && (nfShowEstate?.observacao || nfShowEstate?.dados_migracao?.Observacao)) || "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid container size={12}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Itens</Box>
                                                </Grid>
                                                <Grid size={12}>
                                                    {nfShowEstate?.itens?.map((row: any) => (
                                                        <>
                                                            <Typography className={classes.pos}>
                                                                <b>Código:</b> {row.codigo} <br/>
                                                                <b>Nome:</b> {row.nome} <br/>
                                                                <b>Quantidade:</b> {row.quantidade}
                                                            </Typography>
                                                        </>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {!isMobile && (
                                            <Grid container size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Histórico</Box>
                                                    <Box component={"p"}>Selecione abaixo um registro para visualizar todo o histórico</Box>
                                                    <TableContainer component={Paper}>
                                                        <Table size="small" aria-label="a dense table" className={classes.tableHistorico}>
                                                            <TableBody>
                                                                {nfHistoricoEstate?.map((row: any) => {
                                                                    return (
                                                                        <TableRow key={row?.id} style={{background: `${(nfShowEstate?.data_criacao === row.data_criacao || nfHistoricoEstate?.length === 1)? 'rgba(0, 0, 0, 0.54)' : ''}`}} onClick={() => {
                                                                            setNFHistoricoLinha(row)
                                                                        }}>
                                                                        <TableCell component="th" scope="row">
                                                                            {formatData(row?.data_criacao || row?.created_at)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                    )
                                                                })}
                                                                {!nfHistoricoEstate?.length && nfShowEstate && (
                                                                    <TableRow key={nfShowEstate?.id} style={{background: 'rgba(0, 0, 0, 0.54)'}} onClick={() => {
                                                                            setNFHistoricoLinha(nfShowEstate)
                                                                        }}>
                                                                        <TableCell component="th" scope="row">
                                                                            {formatData(nfShowEstate?.data_criacao || nfShowEstate?.created_at)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={isMobile ? tabMobile : valueState} index={12}>
                                    <Grid ref={contentRef} container spacing={1} className="modal-detalhes-tab">
                                        {isMobile && (
                                            <Grid container size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"} style={{ marginBottom: 5 }}>Histórico</Box>
                                                    {!!listHitoricoPedido?.length && (
                                                        <Box style={{ marginBottom: 10 }}>
                                                            <Typography className={classes.label} color="textSecondary">
                                                                Selecione abaixo um registro para visualizar todo o histórico:
                                                            </Typography>
                                                            <InputSelectSimple
                                                                fullWidth
                                                                label={undefined}
                                                                defaultValue={currentHistoricoPedido}
                                                                value={listHitoricoPedido?.find((i:any) => i.value === currentHistoricoPedido)?.value || ""}
                                                                list={listHitoricoPedido}
                                                                onChange={(value) => {
                                                                    setCurrentHistoricoPedido(value);
                                                                    setPedidoLinhaHistoricosErp(pedidoHistoricosErp?.find((row: any) => row?.data_evento === value))
                                                                }}
                                                            />
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid container size={{ xs: 12, md: 8 }}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Dados do pedido</Box>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Data de emissão:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoShowHistoricosErp?.data_emissao_pedido_erp ? validarData(pedidoShowHistoricosErp?.data_emissao_pedido_erp) : "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Nome transportadora:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoShowHistoricosErp?.rastreamentos?.[0]?.nome_transportadora || "-"}
                                                </Typography>
                                            </Grid>
                                            {!isMobile && (
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                        Situação:
                                                    </Typography>
                                                    <Typography className={classes.pos} color="textSecondary">
                                                        {(projetoState?.origem === 'V1' && pedidoShowHistoricosErp?.dados_migracao?.Situacao ) || "-"}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Número:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoShowHistoricosErp?.pedido_erp || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Valor total (R$):
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {Formater.toString(pedidoShowHistoricosErp?.valor_pagamento || 0, TypeRecords.CURRENCY)}
                                                </Typography>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography className={classes.principal} variant="h5" component="h2">
                                                    Transportadora:
                                                </Typography>
                                                <Typography className={classes.pos} color="textSecondary">
                                                    {pedidoShowHistoricosErp?.rastreamentos?.[0]?.cnpj_transportadora || (projetoState?.origem === 'V1' && pedidoShowHistoricosErp?.dados_migracao?.NomeTransportadora) || "-"}
                                                </Typography>
                                            </Grid>
                                            {!isMobile && (
                                                <>
                                                    <Grid size={{ xs: 12, md: 6 }}>
                                                        <Typography className={classes.principal} variant="h5" component="h2">
                                                            Observações:
                                                        </Typography>
                                                        <Typography className={classes.pos} color="textSecondary">
                                                            {"-"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, md: 6 }}>
                                                        <Typography className={classes.principal} variant="h5" component="h2">
                                                            Situação avaliação:
                                                        </Typography>
                                                        <Typography className={classes.pos} color="textSecondary">
                                                            {(projetoState?.origem === 'V1' && pedidoShowHistoricosErp?.dados_migracao?.SituacaoAvaliacao) || "-"}
                                                        </Typography>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid container size={12}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Itens</Box>
                                                </Grid>
                                                <Grid size={12}>
                                                    {pedidoShowHistoricosErp?.pedido_erp ? 
                                                    [
                                                        ...modulosPedidosHistoricosState,
                                                        ...inversoresPedidosHistoricosState,
                                                        ...estruturasPedidosHistoricosState,
                                                        ...acessoriosPedidosHistoricosState,
                                                        ...bateriasPedidosHistoricosState,
                                                        ...controladoresPedidosHistoricosState,
                                                        ...iluminacaoPedidosHistoricosState
                                                    ].map(renderProductPedidoRow) : ""}

                                                    {pedidoShowHistoricosErp?.notas_fiscais?.[0]?.itens?.map((row: any) => (
                                                         <>
                                                            <Typography className={classes.pos}>
                                                                <b>Código:</b> {row.codigo} <br/>
                                                                <b>Nome:</b> {row.nome} <br/>
                                                                <b>Quantidade:</b> {row.quantidade}
                                                            </Typography>
                                                        </>
                                                    ))}
                                                    {!!itensPedido?.length && itensPedido?.map((row: any) => (
                                                         <>
                                                            <Typography className={classes.pos}>
                                                                <b>Código:</b> {row.Produto} <br/>
                                                                <b>Nome:</b> {row.DescricaoItemPedido} <br/>
                                                                <b>Quantidade:</b> {row.QuantidadeEntregue}
                                                            </Typography>
                                                        </>
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {!isMobile && (
                                            <Grid container  size={{ xs: 12, md: 4 }}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Histórico</Box>
                                                    <Box component={"p"}>Selecione abaixo um registro para visualizar todo o histórico</Box>
                                                    <TableContainer component={Paper}>
                                                        <> {pedidoHistoricosErp?.map((row: any) => (
                                                                <Table size="small" aria-label="a dense table" className={classes.tableHistorico}>
                                                                    <TableBody>
                                                                        <TableRow key="pedido-erp" 
                                                                            style={{background: (pedidoShowHistoricosErp?.data_evento === row?.data_evento) ? `rgba(0, 0, 0, 0.54)` : ''}} 
                                                                            onClick={() => setPedidoLinhaHistoricosErp(row)}
                                                                        >
                                                                            <TableCell component="th" scope="row">
                                                                                {moment(row?.data_evento).format("DD/MM/YYYY - HH:mm:ss")}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            ))}</>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={isMobile ? tabMobile : valueState} index={13}>
                                    <Grid ref={contentRef} container spacing={1}>
                                        <Grid container size={{ xs: 12, md: 8 }}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Entrega</Box>
                                            </Grid>
                                            { projetoState?.origem === "V2" || pedidoEstate?.rastreamentos?.[0]?.link_rastreio 
                                                ? (
                                                    <>
                                                        <Grid size={12}>
                                                            <Typography className={classes.principal} variant="h5" component="h2">
                                                                Status da entrega:
                                                            </Typography>
                                                            <Typography className={classes.pos} color="textSecondary">
                                                                {pedidoEstate?.rastreamentos?.[0]?.ocorrencia || '-'}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid size={12}>
                                                            <Typography className={classes.principal} variant="h5" component="h2">
                                                                Link para rastrear a mercadoria:
                                                            </Typography>
                                                            {pedidoEstate?.rastreamentos?.[0].link_rastreio && 
                                                                <Typography className={classes.pos} color="textSecondary">
                                                                    <a target="_blank" href={pedidoEstate?.rastreamentos?.[0].link_rastreio} rel="noreferrer">Clique aqui</a>
                                                                </Typography>
                                                            }
                                                        </Grid>
                                                    </>
                                                ) : (
                                                    <>
                                                        {historicosProjeto?.map(historico => {
                                                            if (!historico?.descricao) return (<></>);
                                                            return (
                                                                <Grid size={12}>
                                                                    <Typography className={classes.principal} variant="h5" component="h2">
                                                                        {formatData(historico?.data, "DD/MM/YYYY - HH:mm") || '-'}
                                                                    </Typography>
                                                                    <Typography className={classes.pos} color="textSecondary">
                                                                        {historico?.descricao || '-'}
                                                                    </Typography>
                                                                </Grid>
                                                            )
                                                        })}
                                                    </>
                                                )
                                            }
                                        </Grid>
                                    </Grid>
                                </TabPanel>     
                                <TabPanel value={isMobile ? tabMobile : valueState} index={14}>
                                    <Grid ref={contentRef} container spacing={1}>
                                        <Grid container size={12}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Datas de aceite do faturamento</Box>
                                            </Grid>
                                            { previsaoTermosV1 ? (
                                                    <>
                                                       <Grid size={12}>
                                                            <FormControlLabel control={
                                                                <Checkbox
                                                                    checked={true}
                                                                    disabled={true}
                                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                />
                                                            } label={`Termo aceito em ${formatData(projetoState?.dados_finalizar?.confirmado_em)} ${projetoState?.dados_migracao?.projetoV1?.CriadoPor || ''}`} />
                                                            </Grid>
                                                        <Grid size={12}>
                                                            <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: isMobile ? '4px 0px' :'4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                                                                <Typography className={classes.principal} variant="h5" component="h5">
                                                                    Termos do projeto
                                                                </Typography>
                                                                <Box 
                                                                    component='p' 
                                                                    dangerouslySetInnerHTML={{__html: 
                                                                        projetoState?.dados_finalizar?.texto_aceito || projetoState?.dados_migracao?.projetoV1?.TextoAceito || '' 
                                                                    }} 
                                                                />
                                                            </blockquote>
                                                        </Grid>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Grid size={12}>
                                                            <FormControlLabel control={
                                                                <Checkbox 
                                                                    disabled
                                                                    checked={!!projetoState?.dados_finalizar}
                                                                />
                                                            } label={projetoState?.dados_finalizar 
                                                                ? `Projeto aceito em - ${formatData(projetoState?.dados_finalizar?.confirmado_em)} ${projetoState?.dados_finalizar?.user_name ?' - '+projetoState?.dados_finalizar?.user_name:""}`
                                                                : `Projeto aceito`
                                                            } />
                                                        </Grid>
                                                        { (projetoState?.tipo !== 'dimensionado' && projetoState?.tipo !== 'personalizado') && (
                                                            <Grid size={12}>
                                                                <Box component={"span"}>{formatData(criado_em)}</Box>
                                                            </Grid>
                                                        )}
                                                        <Grid size={12}>
                                                            {projetoState?.dados_finalizar && (
                                                                <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: isMobile ? '4px 0px' :'4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                                                                    <TermosFinalizar termos={{
                                                                        ...projetoState?.dados_finalizar,
                                                                        migrado: projetoV1,
                                                                        label: <></>
                                                                    }}/>
                                                                </blockquote>
                                                            )}
                                                        </Grid>
                                                    </>
                                                )
                                            }
                                            
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                {!!projetoState?.visita_tecnica_texto && <TabPanel value={isMobile ? tabMobile : valueState} index={20}>
                                    <Grid ref={contentRef} container spacing={1}>
                                        <Grid container size={12}>
                                            <Grid size={12}>
                                                <Box component={"h4"}>Datas de aceite da visita técnica</Box>
                                            </Grid>
                                            <Grid size={12}>
                                                <FormControlLabel control={
                                                    <Checkbox
                                                        checked={true}
                                                        disabled={true}
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />
                                                } label={`Termos de aceite em ${moment(projetoState?.data_visita_tecnica).format("DD/MM/YYYY - HH:mm:ss")}- ${projetoState?.confirmado_por?.nome}`} />
                                            </Grid>
                                            <Grid size={12}>
                                                <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: isMobile ? '10px 20px' :'4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                                                    <Typography className={classes.principal} variant="h5" component="h5">
                                                        Confirmar visita técnica!
                                                    </Typography>
                                                    {renderTextoVisitaTecnica()}
                                                </blockquote>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>}
                                {!!projetoState?.dados_termo && projetoState?.tipo !== 'vertical' && (
                                    <TabPanel value={isMobile ? tabMobile : valueState} index={21}>
                                        <Grid ref={contentRef} container spacing={1}>
                                            <Grid container size={12}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Datas de aceite dos termos do projeto</Box>
                                                </Grid>
                                                <Grid size={12}>
                                                    <FormControlLabel control={
                                                        <Checkbox
                                                            checked={true}
                                                            disabled={true}
                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                        />
                                                    } label={`Termo aceito em ${moment(projetoState?.dados_termo.aceito_em).format("DD/MM/YYYY - HH:mm:ss")} ${projetoState?.dados_termo?.user_name ? ` - ${projetoState?.dados_termo?.user_name}` : ''}`} />
                                                    </Grid>
                                                <Grid size={12}>
                                                    <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: isMobile ? '10px 20px' :'4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                                                        <Typography className={classes.principal} variant="h5" component="h5">
                                                            Termos do projeto
                                                        </Typography>
                                                        {Array.isArray(projetoState?.dados_termo?.texto) ? 
                                                            projetoState?.dados_termo?.texto.map(t => {
                                                                return <Box component='p' dangerouslySetInnerHTML={{__html: t }} />
                                                            })
                                                        : <Box component='p' dangerouslySetInnerHTML={{__html: projetoState?.dados_termo?.texto }} />}
                                                    </blockquote>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}

                                {!projetoState?.visita_tecnica_texto && visitaTecnicaV1 && (
                                    <TabPanel value={isMobile ? tabMobile : valueState} index={20}>
                                        <Grid ref={contentRef} container spacing={1}>
                                            <Grid container size={12}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Datas de aceite da visita técnica</Box>
                                                </Grid>
                                                <Grid size={12}>
                                                    <FormControlLabel control={
                                                        <Checkbox
                                                            checked={true}
                                                            disabled={true}
                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                        />
                                                    } label={`Termos de aceite em ${formatData(projetoState?.dados_visita_tecnica?.data_visita_tecnica)}- ${projetoState?.dados_visita_tecnica?.confirmado_visita_tecnica_por}`} />
                                                </Grid>
                                                <Grid size={12}>
                                                    <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: '4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                                                        <Box component='p' dangerouslySetInnerHTML={{__html: projetoState?.dados_visita_tecnica?.visita_tecnica_texto || '' }} />
                                                    </blockquote>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}

                                {projetoState?.dados_finalizar_renovigi?.observacao && (
                                    <TabPanel value={isMobile ? tabMobile : valueState} index={22}>
                                        <Grid ref={contentRef} container spacing={1}>
                                            <Grid container size={12}>
                                                <Grid size={12}>
                                                    <Box component={"h4"}>Justificativa</Box>
                                                    <Typography style={{ marginBottom: 10 }} variant="subtitle2" color="textSecondary">Projeto finalizado em {DateUtil.dateFormat(new Date(projetoState.dados_finalizar_renovigi.finalizado_em), "DD/MM/yyyy HH:mm:ss")} por {projetoState.dados_finalizar_renovigi.user_name}.</Typography>
                                                </Grid>

                                                <Box className="row" marginTop={'5px'}>
                                                    <Box py={2} borderRadius="8px" bgcolor='#61616121' borderLeft={"10px solid #8BE68A"} className="X12" textAlign={'left'} padding={'10px'}>
                                                        <span style={{ whiteSpace: "pre-wrap" }}>{projetoState.dados_finalizar_renovigi.observacao}</span>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                )}
                            </Grid>
                        </Box>
                    </DialogContent>
                    <FooterBottom className="footer-modal-detalhes" style={isMobile ? { display: "flex", flexDirection: "column-reverse", width: "100%" } : {}}>
                        <FlatButton
                            color={isMobile ? "secondary" : "inherit"}
                            variant={isMobile ? "outlined" : "contained"}
                            disableElevation
                            text="Fechar"
                            onClick={handleClose}
                            fullWidth={isMobile}
                        />
                        {mostrarBotaoEnviarWhatsapp && (
                            <Tooltip title={projetoState.telefone_proposta ? 'Ao clicar, você será direcionado para a página do WhatsApp' : 'O projeto não tem telefone vinculado'}>
                                <span>
                                    <Button
                                        disabled={!projetoState.telefone_proposta}
                                        onClick={async () => {
                                            const temPermissaoDeProposta = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes) || PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)

                                            const telefone = (projetoState?.telefone_proposta || '').toString()
                                            let wppMessage = temPermissaoDeProposta ? (mensagemWhatsAppProposta || '') : ''
                                            const tipoProposta = projetoState?.tipo_proposta_envio || '';
                                            let url = ''

                                            if (projetoState.segmento?.includes("vertical"))  {
                                                wppMessage = ''
                                            }

                                            if (!tipoProposta || tipoProposta === 'link') {
                                                const novoTipoProposta = handleShowProposta('whatsapp')
                                                if (!novoTipoProposta) return;
                                                url = WhatsAppUtil.montarUrlProposta(novoTipoProposta, projetoState?.codigo_venda || '', telefone, wppMessage)
                                            } else {
                                                url = WhatsAppUtil.montarUrlProposta(tipoProposta, projetoState?.codigo_venda || '', telefone, wppMessage)
                                            }

                                            if (url) {
                                                window.open(url, "_blank", "noopener,noreferrer");
                                                await projetosProvider.registrarEnvioPropostaWhatsapp(projetoState?.id || 0, 'modal-detalhes');
                                            }
                                        }}
                                        color='primary'
                                        disableElevation
                                        variant="contained"
                                        >
                                        <WhatsApp />
                                    </Button>
                                </span>
                            </Tooltip>
                        )}
                        {mostrarBotaoVisualizarProposta && (
                            <>
                                <FlatButton
                                    disabled={!projetoState?.componentes?.length}
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    text="Visualizar Proposta"
                                    onClick={() => handleShowProposta('visualizar')}
                                    fullWidth={isMobile}
                                />
                            </>
                        )}
                    </FooterBottom>
                </Dialog>}


                {(openModalVisualizarProposta) && (
                    <ModalVisualizarProposta
                        tipo={tipoVisualizacaoProposta}
                        open={openModalVisualizarProposta}
                        setOpenModal={handleOpenModalVisualizarProposta}
                        projeto={projetoState}
                    />
                )}            
                
                {(openModalBaixarProposta) && (
                    <ModalBaixarProposta
                        tipo={tipoVisualizacaoProposta}
                        open={openModalBaixarProposta}
                        setOpenModal={handleOpenModalBaixarProposta}
                        projeto={projetoState}
                    />
                )}

                {tipoPropostaModalIsOpened && <TipoPropostaModal
                    isOpened={tipoPropostaModalIsOpened.status}
                    close={() => setTipoPropostaModalIsOpened({ status: false, origem: '' })}
                    onConfirm={async (tipoProposta) => {
                        if (tipoPropostaModalIsOpened.origem === 'whatsapp') {
                            const temPermissaoDeProposta = PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA, permissoes) || PermissionUtil.can(PermissionUtil.PERMISSION_ACAO_VISUALIZAR_PROPOSTA_SIMPLIFICADA, permissoes)

                            const telefone = (projetoState?.telefone_proposta || '').toString()
                            let wppMessage =  temPermissaoDeProposta ? (mensagemWhatsAppProposta || '') : ''

                            if (projetoState?.segmento?.includes("vertical")) {
                                wppMessage = ''
                            }

                            const url = WhatsAppUtil.montarUrlProposta(tipoProposta, projetoState?.codigo_venda || '', telefone, wppMessage)
                            window.open(url, "_blank", "noopener,noreferrer");
                            setTipoPropostaModalIsOpened({ status: false, origem: '' })
                            await projetosProvider.registrarEnvioPropostaWhatsapp(projetoState?.id || 0, 'modal-detalhes');
                        } else {
                            setTipoVisualizacaoProposta(tipoProposta)
                            if (baixarProposta) {
                                setOpenModalBaixarProposta(true);
                            } else {
                                setOpenModalVisualizarProposta(true);
                            }
                            setTipoPropostaModalIsOpened({ status: false, origem: '' })
                        }
                    }}
                />}

                {!!modalComponentesDetalhesData && <ModalDetalhesComponentes
                    open={!!modalComponentesDetalhesData}
                    setOpenModal={(openStatus: boolean) => openStatus ? null : setModalComponentesDetalhesData(0)}
                    componentId={modalComponentesDetalhesData}
                />}
            </div>
        </>
    );
}

export { ModalDetalhes }